//
import store, { clearPersistedState } from "../../store";

import router from "../../router";
import { bus } from '../../app.js'
import { result } from "lodash";

// import { jsPDF } from "jspdf"; 2025-08-15 jazz
// import autoTable from 'jspdf-autotable'; 2025-08-15 jazz

//2025-08-13 jazz
// import * as SetsubiSheet from './SetsubiSheet';
// import * as GaibuList from './GaibuList';
// import * as BasicSpecs from './BasicSpecs';

import * as Const from './Constants';
import pako from './Pako'; //2025-10-02 jazz, change pako lib path

export class SRSDefaults{
    static axiosObj        = null; //2025-09-29 jazz
    static fontAsBase64    = null;
    static visibleCategory = [];
    static Const           = Const;

    //2025-04-08 jazz
    static CellHintArr     = [];
    static TDHeightArr     = [];
	
	//Added Mae 2026-10-07
	static getImageUrl(imagename){
		if(!imagename) return '';
		const hasExt = /\.(jpe?g|png)$/i.test(imagename);
		return '/images/srs_image/' + encodeURIComponent(imagename) + (hasExt ? '' : '.jpg');
	}
	
	//Added Mae 2026-10-05
	static navigationListStyle(index, sheetItems){
		const isFirst = index === 0;
		const isLast = index === sheetItems.length - 1;

		return {
			borderTop: isFirst ? 'none' : '1px solid #cccccc',
			borderBottom: isLast ? '1px solid #cccccc' : 'none',
			borderRight: 'none',
			backgroundColor: '#FFFFFF',
		};
	}

        //2026-09-07 jazz
    static isChangeHinbanOnly = (judgeObj) => {
        if (!store.state.PlanInfo.isPrevious || judgeObj.obsoleteddate == null || judgeObj.groupid != -1) {
            return judgeObj;
        }

        const selectedSRSItems = store.state.PlanInfo.SelectedItems;

        const hasMatch = selectedSRSItems.some(item => 
            item.MasterId === judgeObj.masterid && 
            item.TextureId === judgeObj.id && 
            item.TextureIsObsoleted == null
        );

        if (hasMatch) {
            judgeObj.obsoleteddate = null;
        }

        return judgeObj;
    }
 
    //2025-05-13 jazz
    static isNeedToCompleteCountChecked = false;

    //Added Line 2026-03-23 jazz, for GC Plan
    static isGCPlan = (constructionCode) =>{
        let result = false;

        if(/^(A|B|D).{6}-\d{4}/.test(constructionCode)){
            result = true;
        }

        return result;         
    }
	
    //mae added 2025-09-29
    static isDisableConstuction = (CRSOpenOnly) => {
        let result = true;

        if( store.state.Referrer == "CadRequestSystem" && CRSOpenOnly ){

            if( store.state.PlanInfo.CopyPlan == true){
                result = true;
            }else{
                // if( /\(SS|Sent\)$/.test(store.state.PlanInfo.CurrentMenu)){
                if( /\(SS|Sent\)$/.test(store.state.PlanInfo.CurrentMenu)){ //2025-09-30 jazz regexp change
                    result = false;
                }else{
                    result = true;
                } 
            }
        }else{
            result = false;
        }
        
        return result
    }

    //mae added 2025-09-29
    static isDisable_PlanNumbers = (CRSOpenOnly) => {
        let result = true;

        if( store.state.Referrer == "CadRequestSystem" && CRSOpenOnly ){

            if( store.state.PlanInfo.CopyPlan == true){
                result = false;
            }else{
                // if( /\(SS|Sent\)$/.test(store.state.PlanInfo.CurrentMenu)){
                if( /\((SS|Sent)\)$/.test(store.state.PlanInfo.CurrentMenu)){ //2025-09-30 jazz regexp change
                    result = false;
                }else{
                    result = true;
                }
            }
        }else{
            result = false;
        }
        
        return result
    }
    //mae added 2025-09-09
    static displayCompletedMark = (tmpObj) => {
        let result = false;
        for (var j = store.state.PlanInfo.SelectedItems.length - 1; j >= 0; j--){
            if( store.state.PlanInfo.SelectedItems[j].MainCategoryName == tmpObj.items && tmpObj.iscompleted){
                result = true;
            }
        }
        return result;
    }    

    //2025-07-11 jazz, open boss pdf in new window
    static OpenPDFInNewWindow = (data) =>{
            const pdfFile = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(pdfFile);

            // Define window features for the new window
            const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes';

            // Open the PDF in a new window with specified features
            const newWindow = window.open(url, '_blank', windowFeatures);

            // Check if the new window was successfully opened
            if (newWindow) {
                newWindow.focus(); // Bring the new window to the front
            } else {
                // Handle the case where the new window could not be opened (e.g., popup blocker)
                alert('Please allow popups for this website to view the PDF.');
            }

            // Clean up the object URL after a short delay
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 100); 
    } 

    // //2025-08-08 jazz, check toilet/systembath execute only when changed
    // static BathroomFixturesPresets = async(maincategoryObj, categoryid, item ) =>{
    //     let result = false;

    //     const tmpObj = {mainid: maincategoryObj.id, seq: maincategoryObj.seq, id: categoryid}

    //     if(store.state.UserInterface[`SelectedWhenActive${item}`].length == 0){
    //         result = true;
    //     }else{
    //         const seqIdx = store.state.UserInterface[`SelectedWhenActive${item}`].findIndex(item => item.seq === maincategoryObj.seq);
 
    //         if(seqIdx > -1){
    //             if(store.state.UserInterface[`SelectedWhenActive${item}`][seqIdx].id != categoryid){
    //                 result = true;
    //             }
    //         }else{
    //             result = true;
    //         }
    //     }

    //     if(result){
    //         await store.dispatch(`SelectedWhenActive${item}`, tmpObj)
    //         await this.SetPreselectedWhenActive(maincategoryObj, 'Texture');    
    //     }


    //     if(maincategoryObj.id != this.Const.SYSTEM_BATH_ID){
    //         let idxToRemove = [];

    //         for(let i = 0; i < store.state.UserInterface[`SelectedWhenActive${item}`].length; i++){
    //             for(let j = 0; j < store.state.PlanInfo.SelectedItems.length; j++){
    //                 if(store.state.PlanInfo.SelectedItems[j].MainCategoryId == this.Const.SYSTEM_BATH_ID) continue;

    //                 if(store.state.PlanInfo.SelectedItems[j].MainCategoryId != store.state.UserInterface[`SelectedWhenActive${item}`][i].mainid) continue;
    //                 if(this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(store.state.PlanInfo.SelectedItems[j].CategoryId)) continue;

    //                 if(store.state.PlanInfo.SelectedItems[j].Seq === store.state.UserInterface[`SelectedWhenActive${item}`][i].seq){
    //                     if(store.state.PlanInfo.SelectedItems[j].CategoryId !== store.state.UserInterface[`SelectedWhenActive${item}`][i].id){
    //                         idxToRemove.push(j);

    //                     }
    //                 }
    //             }
    //         }

    //         for (var i = idxToRemove.length - 1; i >= 0; i--) {
    //             await store.state.PlanInfo.SelectedItems.splice(idxToRemove[i], 1)
    //         }
    //     }

    //     return result;
    // }

    //2025-08-08 jazz, check toilet/systembath execute only when changed
    static SetBathroomFixturesPresets = async(maincategoryObj, categoryid ) =>{
        let result = false;

        const tmpObj = {mainid: maincategoryObj.id, seq: maincategoryObj.seq, id: categoryid}

        if(store.state.UserInterface.SelectedWhenActiveToiletFixtures.length == 0){
            result = true;
        }else{
            const seqIdx = store.state.UserInterface.SelectedWhenActiveToiletFixtures.findIndex(item => item.mainid == maincategoryObj.id && item.seq == maincategoryObj.seq);
 
            if(seqIdx > -1){
                if(store.state.UserInterface.SelectedWhenActiveToiletFixtures[seqIdx].id != categoryid){
                    result = true;
                }
            }else{
                result = true;
            }
        }

        let __t = performance.now();

        if(result){
            //2026-10-07 jazz, neither call is awaited any more, for the same reason the splice loop below
            //is no longer awaited: each await yielded to the microtask queue and let Vue flush a complete
            //re-render of the sheet (~750ms each, measured). Dropping them lets both mutations batch into
            //one render. Both are safe to call synchronously:
            //  - the SelectedWhenActiveToiletFixtures action is `async (ctx,p) => await ctx.commit(...)`,
            //    and commit() is synchronous, so the state is already updated when dispatch() returns;
            //    the promise it hands back carries no state we depend on
            //  - SetPreselectedWhenActive contains no await at all, so it runs to completion synchronously
            //    and the loop below sees the SelectedItems it pushed
            //If either ever gains genuinely asynchronous work, the awaits must come back.
            store.dispatch('SelectedWhenActiveToiletFixtures', tmpObj)
            this.SetPreselectedWhenActive(maincategoryObj, 'Texture');
        }

        if(maincategoryObj.id != this.Const.SYSTEM_BATH_ID){
            let idxToRemove = [];

            for(let i = 0; i < store.state.UserInterface.SelectedWhenActiveToiletFixtures.length; i++){
                for(let j = 0; j < store.state.PlanInfo.SelectedItems.length; j++){
                    if(store.state.PlanInfo.SelectedItems[j].MainCategoryId == this.Const.SYSTEM_BATH_ID) continue;

                    if(store.state.PlanInfo.SelectedItems[j].MainCategoryId != store.state.UserInterface.SelectedWhenActiveToiletFixtures[i].mainid) continue;
                    if(this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(store.state.PlanInfo.SelectedItems[j].CategoryId)) continue;

                    if(store.state.PlanInfo.SelectedItems[j].Seq === store.state.UserInterface.SelectedWhenActiveToiletFixtures[i].seq){
                        if(store.state.PlanInfo.SelectedItems[j].CategoryId !== store.state.UserInterface.SelectedWhenActiveToiletFixtures[i].id){
                            idxToRemove.push(j);

                        }
                    }
                }
            }


            //2026-10-07 jazz, do NOT await here. splice() returns an Array, never a Promise, so the
            //await bought no sequencing - but it did yield to the microtask queue on every iteration,
            //which let Vue flush a complete re-render of the sheet between each removal. Measured on a
            //1F toilet texture click: 5 removals cost 4118ms, i.e. ~820ms per splice, which is the cost
            //of one full re-render of this table. Running the splices synchronously lets Vue batch them
            //into a single re-render. Same resulting array either way.
            for (var i = idxToRemove.length - 1; i >= 0; i--) {
                store.state.PlanInfo.SelectedItems.splice(idxToRemove[i], 1)
            }

        }

        return result;
    }
	
    //mae added for bgcolor item that with changes only
    static isModifiedItem = ( maincategory, rowindex ) => {

        let result = false;

        store.state.PlanInfo.SelectedItems.map(planInfo => {
            if(planInfo.MainCategoryName === maincategory.name && planInfo.RowIndex === rowindex && planInfo.Modified){
                result = true;
            }
        })

        return result;
    }

    static DecompressData = ( compressedData ) => {
        try {
            const decompressedData = pako.inflate(compressedData, { to: 'string' });
            return JSON.parse(decompressedData);
        } catch ( error ) {
            console.log(error)
            return compressedData
        }
    }

    static CompressData = ( data ) =>{
        return pako.deflate(JSON.stringify(data), { to: 'string' });
    }

    static UpdateSRS = ( paramObj ) =>{
        if ( this.isHRDMode() ) return;

        const socketData  = paramObj.data
        const swal        = paramObj.swal 
        const progressBar = paramObj.progressBar

        let newVersion = null

        if ( socketData.request === 'pushUpdates' ) {
            const latestVersion = `v1.${socketData.updateInfo.revision}.${socketData.updateInfo.version}`;

            if ( store.state.Master.UIVersion == latestVersion ) return;  

            if ( newVersion && newVersion != store.state.Master.UIVersion){
                bus.$emit ( 'IsUpdateBadgeVisible', true )
            } else {
                bus.$emit( 'IsUpdateBadgeVisible', false )
            }

            if(newVersion) return;

            newVersion = `v1.${socketData.updateInfo.revision}.${socketData.updateInfo.version}`
 
            swal({
                icon: 'warning',
                html: Const.NEW_VERSION_INFO.replace( '-####-', newVersion ) + '<br><br>' +  Const.NEW_VERSION_INFO_EN.replace( '-####-', newVersion ),
                focusCancel: true,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",                            
                confirmButtonText: 'はい(Y)',
                cancelButtonText: 'いいえ(N)'
            }).then( async ( result ) =>{
                if ( result.isConfirmed ) {
                    store.dispatch('ReUpdate', true)

                    progressBar.functionCount = 20
                    await progressBar.show();

                    for ( let i = 0; i < socketData.updateInfo.master_to_update.length; i++ ){
                        this.Logger('info', store.state.UserInfo.FullName, 'App.vue', `successfully update ${socketData.updateInfo.master_to_update[i]} master from update push`, 1)
                        await this.importMasters(socketData.updateInfo.master_to_update[i])
                    }

                    await progressBar.increment(4);
          
                    store.dispatch( 'setUIVersion', latestVersion )

                    await progressBar.forceComplete();
                    await progressBar.hide();
 
                    swal.fire({
                        icon: 'success',
                        title:"Updated",
                        width: '350px',
                        html: Const.CHANGES_WILL_TAKE_EFFECT_NEXT_PLAN_CREATION,
                        showConfirmButton: false,
                        timer: 2000
                    });
 
                    await new Promise( r => setTimeout(r, 3000) ); 
                    //window.location.reload()

                    bus.$emit( 'IsUpdateBadgeVisible', false )
                    newVersion = null
                } else {
                   bus.$emit( 'IsUpdateBadgeVisible', true )
                }
            })
        }
    }

    static scrollDefault = (owner) =>{
        if (store.state.PlanInfo.EditKey == -1) {
            owner.model = null
            owner.$refs.tablesection.scrollTo(0, 0)
            owner.$refs.maincategorysection.scrollTo(0, 0)
            owner.scrollToItem = null
        }
        
        owner.shortcutContainerHeight = window.innerHeight;
    }

    //2025-08-22 jazz
    // static SetHouseTypeFilter = ( itemArr, houseType ) => {
    //     try{
    //         let itemsToReplace = [];
    //         itemArr.forEach(item => {
    //             if (item.housetype.includes(parseInt(houseType))) {
    //                 itemsToReplace.push(item)
    //             }
    //         })
    //         return itemsToReplace
    //     }catch(e){
    //       console.log(e)
    //     }
    // }

    static Logger = (severity, user, component, data, isfrontend) =>{
        try{
            if(process.env.MIX_ALLOW_LOGS == 'false') return;
			
			let tmpVersion = '#' + store.state.Master.UIVersion;

            this.axiosObj.post(`${process.env.MIX_API_BASEURL}/api/log`, {'severity': severity, 'component': component, 'data': data + tmpVersion, 'user': user, 'isfrontend': isfrontend})
        }catch(e){
            alert('cannot log error')
            console.log(e)
        }
    }
 
    static ShowErrorAndRedirect = async ( swal, message, icon, routeToRedirect = null) => {
        //if( swal.isVisible() ) return;

        try {
            swal.fire({
                html: message,
                icon: icon,
                width: '400px',
                allowOutsideClick: false,
                showConfirmButtonColor: "#3085d6",
                didOpen: () => {
                    swal.hideLoading();
                },                          
            }) 

            if ( routeToRedirect ) {
                // router.push( routeToRedirect );
                await new Promise( r => setTimeout ( r, 1000 ) );
                // window.location.replace(routeToRedirect)
            }
        } catch (error) {
            alert('Error showing alert:', error.message);
        }
    }

    //2025-06-16 jazz
    static RestablishingConnections = async ( swal, websocketService, component = null ) => {
        if( swal.isVisible() ) return;

        let connectionId = null;

        //2026-10-09 jazz, only show the "Re-establishing connection" modal when the socket is
        //actually disconnected - this used to fire on every call (incl. a plain slow-response
        //timeout on a healthy socket), popping up before the save had even finished/failed.
        if ( (await websocketService.isConnected()) == false ) {
            swal.fire({
                icon: "info",
                width: '350px',
                allowOutsideClick: false,
                html: '接続を再確立しています...' + '<br>' + 'Re-establishing connection...',
                showConfirmButton: false,
                timer: 1500,
                didOpen: () => {
                    swal.showLoading();
                },
            })

            console.log('socket disconnected, reconnecting')

            this.Logger('warning', store.state.UserInfo.FullName, component, 'disconnected from socket, attempt reconnect for newplan...', 1);

            await websocketService.connect( store.state.UserInfo.FullName );
            await websocketService.joinRoom({systemName: "SRS", roomName: process.env.MIX_SOCKET_ROOM, userName: store.state.UserInfo.FullName })
            connectionId = await websocketService.getConnectionId()

            if( connectionId ){
                console.log('reconnected')
                this.Logger('warning', store.state.UserInfo.FullName, 'newplan.vue', 'successfully reconnected in socket', 1);
            }
        }

        this.Logger('warning', store.state.UserInfo.FullName, component, `Auto Reconnect`, 1)

        return connectionId;
    }
    
    //2025-08-22 jazz 
    // static isMobile(){
    //     result = false
    //     if ("ontouchstart" in document.documentElement){
    //         result = true;
    //     }

    //     return result;
    // }

    static isPlanExist = async (constructionCode, planNumber, requestNumber, planStatus) =>{
        let result = false;
        const uri = `${process.env.MIX_API_BASEURL}/api/checkPlanIfExist?construction_code=${constructionCode}&plan_status_code=${planStatus}&plan_no=${planNumber}&shio_no=${requestNumber}`
        
        const response = await this.axiosObj.get(uri)

        if(response.data.length > 0){
            result = true;
        }

        return result;
    }

    static importHouseTypes = async () =>{
        let tmpHouseTypeArr = [];
        try{

          //2024-05-13 Get in Socket jazz
          //const houseTypeShiyousho = (await axios.get(`${process.env.MIX_API_BASEURL}/api/shiyo-common/housetypes`)).data;
          const houseTypeSRS = (await this.axiosObj.get(`${process.env.MIX_API_BASEURL}/api/houseTypes`)).data;

          // houseTypeSRS.forEach(srshousetype => {
          //   for(let i = 0; i < houseTypeShiyousho.length; i++){
          //       if(srshousetype.TYPE_CD === houseTypeShiyousho[i].TYPE_CD){
          //           srshousetype.HouseType = houseTypeShiyousho[i].TYPE_MEI
          //       }
          //   }
          // })

          //await this.toggleLoading(true, 'updating house types, please wait...')
          tmpHouseTypeArr.push(...houseTypeSRS);
          tmpHouseTypeArr.sort((a, b) => a.SortNo - b.SortNo);

          store.commit('HouseTypes', tmpHouseTypeArr);
        }catch(error){
        //   alert(error);
            this.$swal({
                text: error,
                icon:'error',
                className:"swalError",
                closeOnClickOutside:false,
                buttons:{
                    text:"ok",
                    className:"swalconfirm"
                }
            })
        } 
    }

    // static showConfirmDialog = (isshown, confirmMessage, confirmDialogWidth, okButtonFunc = null, type = 0) => {
    //     let tmpObj = { message: confirmMessage, dialogWidth: confirmDialogWidth, func: okButtonFunc, dialogType: type } 

    //     bus.$emit('setConfirmMessage', tmpObj)
    //     bus.$emit('showConfirmDialog', true)  
    // }
    
    // static setTextColorForMultiple = ( item ) => {
    //     let result = ''

    //     if ( /\([2-9]\)$/.exec(item) ){
    //         //result = 'blue--text lighten-3';




    //         // switch ( /\([2-3]\)$/.exec(item)[0] ) {
    //         //     case '(2)': result = 'blue--text lighten-3'; break;
    //         //     case '(3)': result = 'green--text lighten-3'; break;
    //         // }
    //     }
    //     return result
    // }

    static setUniqueId = () =>{
        const currentDate = (new Date().toISOString().slice(0, 10)).replaceAll('-','');
        const randNum = (1000 + Math.random() * 9000).toFixed(0);
        return `${currentDate}-${randNum}`;
    }

    //2025-08-22 jazz
    // static TriggerAPIWorker = () =>{
    //     try{
    //         if (window.Worker) {
    //             const webWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/TriggerAPI.js`); //spawn webworker for trigger api
    //             const TriggerURI = `${process.env.MIX_LOCAL_API.split('4001')[0]}5000/api/estimation/plans/${store.state.PlanInfo.ConstructionCode}/${store.state.PlanInfo.RevisionNumber}/${store.state.PlanInfo.RequestNumber}`
    //             webWorker.postMessage( TriggerURI ) //send data to worker
    //         }
    //     }catch(e){
    //       alert(e)
    //     }
    // }

    static ImportFontAPIWorker = () =>{
        try{
            if (window.Worker) {
                const webWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/ImportFont.js`); //spawn webworker for trigger api
                const fontURI = `${process.env.MIX_API_BASEURL}/fonts/SourceHanSansCN-Regular-normal.js`
                webWorker.postMessage( fontURI ) //send data to worker

                webWorker.addEventListener('message', (worker) => {
                    this.fontAsBase64 = worker.data;
                }); 
            }
        }catch(e){
          alert(e)
        }
    }

    static SpawnConvertWebWorkers = async (constructionCode, planNumber, requestNumber, fullName, progressBar, sheetClass, socketData = null) => {
        //need to spawn web workers to run multithread
            let convertWebWorker = null;
 
            try{ 
                if (window.Worker) {
                        progressBar.increment();
                    const houseTypes = store.state.Master.HouseTypes;
                    const selectedHouseType = houseTypes.find( item => item.HouseType == store.state.PlanInfo.HouseType );
                    const typeCd = selectedHouseType?.TYPE_CD || null;
                        progressBar.increment();
						
                    const housetypeID = selectedHouseType?.Id;

                    let tmpURI = `${process.env.MIX_CONVERT_API}/api/srs-siyo-conversion?construction_code=${constructionCode}&plan_no=${planNumber}&shio_no=${requestNumber}&user=${fullName}`;

                    if(store.state.PlanInfo.CopyPlan){
                        tmpURI = `${process.env.MIX_CONVERT_API}/api/srs-siyo-conversion?construction_code=${constructionCode}&plan_no=${planNumber}&shio_no=${requestNumber}&user=${fullName}&judge_housetype=${housetypeID}`
                    }

                    let convertInfo = {
						uri            : tmpURI,
                        SRSKey         : process.env.MIX_API_KEY,
                        gaibuSheetURI  : `${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/${typeCd}/1`,
                        setsubiSheetURI: `${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/${typeCd}/2`,
                        basicSpecsURI  : `${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/${typeCd}/3`
                    }

                    const isHRD = this.isHRDMode();

                    if(!isHRD){
                        convertInfo.uri = null
                    }

                    convertWebWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/ConvertionAPI.js`); //spawn webworker for getting data from API for multithreading
                    convertWebWorker.postMessage( convertInfo )

                    //2026-09-29 jazz, the worker now posts each endpoint's result back independently as soon
                    //as it resolves (see ConvertionAPI.js) instead of one message gated behind Promise.all.
                    //basicSpecs (+ main, in HRD mode) is handled the moment both are in, regardless of whether
                    //the much slower gaibu/setsubi endpoints have responded yet.
                    const received = {};
                    let primaryHandled = false;
                    let gaibuHandled = false;
                    let setsubiHandled = false;

                    const primaryReady = () => (
                        isHRD ? (received.main !== undefined && received.basicSpecs !== undefined)
                              : received.basicSpecs !== undefined
                    );

                    //2026-10-13 jazz, gaibu and setsubi now each hide their own loader as soon as their
                    //own endpoint resolves, instead of both waiting behind whichever of the two is slower.
                    const maybeLoadRemaining = () => {
                        if ( !gaibuHandled && received.gaibu !== undefined ) {
                            gaibuHandled = true;
                            this.LoadSheetFromWorkerData( sheetClass.GaibuList, 'GaibuList', received.gaibu, progressBar )
                        }

                        if ( !setsubiHandled && received.setsubi !== undefined ) {
                            setsubiHandled = true;
                            this.LoadSheetFromWorkerData( sheetClass.SetsubiSheet, 'SetsubiSheet', received.setsubi, progressBar )
                        }
                    };

                    const handlePrimary = async () => {
                        primaryHandled = true;

                        //2026-10-13 jazz, wrap the whole body so that any error past this point (e.g. in
                        //the CopyPlan item-flagging loop or the route navigation below) can't leave
                        //forceComplete() uncalled - this ran inside the worker's onmessage callback with no
                        //surrounding try/catch, so an uncaught throw here became a silent unhandled
                        //rejection that left the progress overlay stuck visible forever even though
                        //BasicSpecs had already finished loading.
                        try{
                            const mainData = isHRD ? received.main : socketData;

                            mainData.progressBar = progressBar
                                progressBar.increment();
                            await store.dispatch('SetPreviousId', 200)

                            await store.dispatch('LoadPlanFromShiyousho', mainData);
                                await progressBar.increment();

                            await sheetClass.BasicSpecs.ImportUserDataToStore(progressBar, received.basicSpecs)
                                await progressBar.increment();

                            if(store.state.PlanInfo.isPrevious != false){
                                this.AddItemsToInterface('BasicSpecs')
                                    await progressBar.increment();
                            }

                            //2025-05-20, jazz display jiban error message
                            if( store.state.PlanInfo.JibanInfo.selectedJibanIdBranch.errcode ){
                                if( store.state.PlanInfo.JibanInfo.selectedJibanIdBranch.errcode === 500 ){
                                    alert(store.state.PlanInfo.JibanInfo.selectedJibanIdBranch.message)
                                    router.push('menu')

                                    return;
                                }
                            }

                            //added by mae if copyPlan default no color 2024-10-22
                            //2025-06-19 jazz, selectedwhenactive
                            //2025-08-15 jazz, selectedwhenactive revised
                            if ( store.state.PlanInfo.CopyPlan == true ) {
                                store.state.PlanInfo.SelectedItems.forEach( item =>{
                                    item.Modified? item.Modified = false : false

                                    if( this.Const.TOILETS_AND_SYSTEM_BATH.includes(item.MainCategoryId) &&
                                        !this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(item.CategoryId)
                                    ){
                                        // let toiletFixtureName = null;

                                        // switch( item.MainCategoryId ){
                                        //     case this.Const.SYSTEM_BATH_ID:
                                        //         toiletFixtureName = 'SystemBath';
                                        //         break;
                                        //     case this.Const.TOILET_1F_ID:
                                        //         toiletFixtureName = 'Toilet1F';
                                        //         break;
                                        //     case this.Const.TOILET_2F_ID:
                                        //         toiletFixtureName = 'Toilet2F';
                                        //         break;
                                        //     case this.Const.TOILET_3F_ID:
                                        //         toiletFixtureName = 'Toilet3F';
                                        //         break;
                                        // }

                                        // store.dispatch( `SelectedWhenActive${toiletFixtureName}`, item.CategoryId )

                                        const tmpObj = {
                                            mainid: item.MainCategoryId,
                                            seq: item.Seq,
                                            id: item.CategoryId
                                        }

                                        store.dispatch('SelectedWhenActiveToiletFixtures', tmpObj)
                                    }
                                });

                                store.state.PlanInfo.JibanInfo.CopiedPlanInfo = store.state.PlanInfo.CopyPlanInfo;
                            }

                            //2026-09-29 jazz, await this - it used to be fire-and-forget, which let
                            //forceComplete() below close the loading overlay before the route had actually
                            //navigated (including fetching BasicSpecs' lazy-loaded chunk), leaving a blank
                            //screen visible for a moment with no loading indicator over it.
                            await this.setActiveSheetInViewAndIDB(store.state.Master.SheetItems[0])

                            this.Logger(
                                'info', store.state.UserInfo.FullName,
                                'ExistingPlan.vue',
                                `Success Load Shiyo Previous: ${constructionCode} ${planNumber} ${requestNumber}`,
                                1
                            )
                        }catch(err){
                            console.log(err)

                            this.Logger(
                                'error', store.state.UserInfo.FullName,
                                'ExistingPlan.vue',
                                `handlePrimary failed after BasicSpecs loaded: ${err.message}`,
                                1
                            )
                        }finally{
                            //2026-09-29 jazz, BasicSpecs is displayed at this point - force the shared
                            //progress overlay closed now instead of letting it linger until enough increment()
                            //calls accumulate from the background gaibu/setsubi loads below (functionCount=100,
                            //so it wouldn't otherwise hide until those slower background imports call increment()
                            //enough times to reach the target). Their own increment() calls become no-ops after
                            //this resets functionCount to 0, so they can't re-open the overlay.
                            await progressBar.forceComplete();
                        }

                        //2026-09-29 jazz, gaibu/setsubi may already have arrived while primary was being
                        //processed above - pick them up immediately if so, instead of waiting for another message.
                        maybeLoadRemaining();
                    };

                    convertWebWorker.onmessage = async (e) => {
                        const { key, data, error } = e.data;

                        //2026-09-29 jazz, on a fetch failure the worker posts { key, error: true } with no
                        //data field, which made `received[key]` stay undefined forever - indistinguishable
                        //from "hasn't arrived yet". That permanently blocked primaryReady()/maybeLoadRemaining()
                        //(sometimes reported as gaibu/setsubi stuck on "infinite loading"), since neither ever
                        //treats an errored key as received. Fall back to an empty array so the pipeline can
                        //still proceed - the affected sheet just ends up with no items instead of hanging.
                        received[key] = error ? [] : data;

                        if ( !primaryHandled && primaryReady() ) {
                            await handlePrimary();
                        } else if ( primaryHandled ) {
                            maybeLoadRemaining();
                        }
                    };
                }
            }catch(e){
              console.log(e)
              progressBar.hide()
            }
    }

    //2026-10-13 jazz, loads a single sheet (GaibuList or SetsubiSheet) from the already-fetched worker
    //payload after BasicSpecs is already shown, so the copy-from-shiyousho flow doesn't block navigation
    //on all three sheets. Each sheet hides its own loader as soon as its own import finishes, instead of
    //both waiting on whichever of the two sheets is slower (see maybeLoadRemaining above).
    static LoadSheetFromWorkerData = async (sheetInstance, sheetKey, data, progressBar) => {
        try{
            await store.dispatch('SheetLoading', { sheet: sheetKey, value: true })

            await sheetInstance.ImportUserDataToStore(progressBar, data)

            if(store.state.PlanInfo.isPrevious != false){
                this.AddItemsToInterface(sheetKey)
            }
        }catch(e){
            console.log(e)
        }finally{
            await store.dispatch('SheetLoading', { sheet: sheetKey, value: false })
        }
    }

    // static WebWorkerGaibu = async () =>{
    //     try{ 
    //         if (window.Worker) {
    //             const webWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/Master.js`); //spawn webworker for getting data from AWS
    //             webWorker.postMessage( process.env.MIX_API_KEY ) //send data to worker


    //             webWorker.addEventListener('message', (worker) => {
    //                 const menuItems  = worker.data[0];
    //                 const masters    = worker.data[1];
    //                 const houseTypes = worker.data[2];
    //                 const roomList   = worker.data[3]; 
    //                 const gaibu      = worker.data[4];
    //                 const kihon      = worker.data[5];
    //                 const setsubi    = worker.data[6];

    //                 //this.toggleLoading(true, 'updating SRS masters, please wait...')

    //                 menuItems.forEach(item => {
    //                     if (item.isavailableintrial == 0 && !this.isDebugMode() ){
    //                         item.backcolor = 'grey'
    //                     }
    //                 })

    //                 store.dispatch('MenuItems', menuItems)


    //                 // if (URI.SRSData.length > 0) {
    //                 //     const ImportDataWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/ImportAWSData.js`); //spawn webworker for getting data from AWS

    //                 //     ImportDataWorker.postMessage( URI ) //send data to worker
    //                 // }

    //             }); 



    //             // AWSWorker.addEventListener('message', (data) => {
    //             //     URI.SRSData = data.data;
    //             //     if (URI.SRSData.length > 0) {
    //             //         const ImportDataWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/ImportAWSData.js`); //spawn webworker for getting data from AWS

    //             //         ImportDataWorker.postMessage( URI ) //send data to worker
    //             //     }
    //             // }); 


    //         }
    //     }catch(e){
    //       console.log(e)
    //     }
    // }

    // static SpawnAWSWebWorkers = () =>{
    //     //need to spawn web workers to run multithread
    //     if (this.isHRDMode()) { 
    //         try{ 
    //             if (window.Worker) {
    //                 let URI = {
    //                     importURI: process.env.MIX_IMPORT_URL,
    //                     saveURI: `${window.location.origin}${process.env.MIX_API_BASEURL}/api/savePlans`,
    //                     SRSKey: process.env.MIX_API_KEY,
    //                     SRSData: []
    //                 }
                    
    //                 const AWSWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/FetchAWSData.js`); //spawn webworker for getting data from AWS
    //                 AWSWorker.postMessage( URI ) //send data to worker
    //                 AWSWorker.addEventListener('message', (data) => {
    //                     URI.SRSData = data.data;
    //                     if (URI.SRSData.length > 0) {
    //                         const ImportDataWorker = new Worker(`${process.env.MIX_API_BASEURL}/webworkers/ImportAWSData.js`); //spawn webworker for getting data from AWS

    //                         ImportDataWorker.postMessage( URI ) //send data to worker
    //                     }
    //                 }); 
    //             }
    //         }catch(e){
    //           console.log(e)
    //         }
    //     }
    // }

    static GetHouseTypeName = async (id, fieldToSearch) =>{
        try{
            let houseTypeObj = null

            //added line 2026-04-22 jazz
            if(id  in [this.Const.CADREQ_ISMART_1F, this.Const.CADREQ_ISMART_2F]){
                id = this.Const.I_SMART_TYPE;
            }
 
            if(store.state.Master.HouseTypes.length > 0){
                houseTypeObj = store.state.Master.HouseTypes.filter(item => item[fieldToSearch] == id)[0]

            }else{
                houseTypeObj = ((await this.axiosObj.get(`${process.env.MIX_API_BASEURL}/api/houseTypes`)).data).filter(item => item[fieldToSearch] == id)[0]
            }

            if(!houseTypeObj){
                return null
            }else{
                return houseTypeObj.HouseType    
            }
        }catch(e){
            console.log(e)
            return null
        }
    }

    //2025-08-22 jazz
    // static SetDefaultSelectedItem = ( itemArr, houseType ) => {
    //     let tmpSelected = {}
    //     itemArr.forEach(item => {
    //       if (item.isselected) {
    //           if (item.items) {
    //               if (item.isselected.includes(parseInt(houseType))) {
    //                   tmpSelected = item.items;
    //               } 
    //           }
    //           if (item.texturename) {
    //               if (item.isselected.includes(parseInt(houseType))) {
    //                   tmpSelected = item.texturename;
    //               } 
    //           }        
    //       }      
    //     }) 
    //     return tmpSelected;
    // }

    //2025-07-07 jazz
    static HouseTypeNumber = () =>{
        try{
            const tmpHouseType = store.state.Master.HouseTypes.filter(item => item.HouseType == store.state.PlanInfo.HouseType)[0]
            return parseInt(tmpHouseType.Id)   
        }catch(e){
            return;
        }
    }

    static isHouseTypeExist = ( stringparam ) =>{
        let result = false

        try{
            if(stringparam) {
                const housetypeArr = JSON.parse(stringparam)     
                if( housetypeArr.includes(this.HouseTypeNumber()) ) {
                    result = true
                }  
            }
            return result
        } catch {
            //console.log('error in SRSFunc, please check database value in housetype isselected')
        }
    }

    static filteredItems = async (maincategory) => {
        try{
            //const storeItems = await store.state.Master[storeName];

            let tmpResult = maincategory.filter(item => item.housetype.includes(parseInt(this.HouseTypeNumber())) )
            tmpResult.sort((a, b) => (a.sortno > b.sortno) ? 1 : (a.sortno === b.sortno) ? ((a.items > b.items) ? 1 : -1) : -1 )
            return tmpResult;
        }catch(e){
            console.log(e)
        }
    }
  
    static itemFilter = (arr) =>{
        try{
            let tmpArr = arr.filter(item =>{ return item.housetype.includes(parseInt(this.HouseTypeNumber())) })
            return tmpArr 
        }
        catch(e){
            console.log(e)
        }
    }


    static isDisplayTriggeredItem = (item) => {        
        let result = [];

        if (Array.isArray(item)) {
            item.forEach(childItem => {   
                // Push each childItem to the result array
                result.push(childItem);
            });
        } else {
            // If item is not an array, just push it to the result
            result.push(item);
        }

        return result;
    } 
	
    static displayTriggeredTexture = (filteredMaincategory, tmpJSON, selectedTexture) =>{

        filteredMaincategory.category.forEach(category =>{

            if(category.textureList){
                category.textureList.forEach(texture =>{
                    if(texture.id === tmpJSON.id){
                        if(tmpJSON.value){
                         return   texture.isinterfacedefault = selectedTexture ? 1:0;          
                        }else{
                         return   texture.isinterfacedefault = 0
                        }
                    }
                }) 
            }

            if(category.subcategory){
                category.subcategory.forEach(item =>{
                    if(item.textureList){
                        item.textureList.forEach(texture =>{
                            if(texture.id === tmpJSON.id){
                                if(tmpJSON.value){
                                   return texture.isinterfacedefault = selectedTexture ? 1:0;          
                                }else{
                                  return  texture.isinterfacedefault = 0
                                }
                            }
                        })
                    }

                    //specs
                    if(item.specs){
                        item.specs.forEach(item =>{
                            if(item.textureList){
                                item.textureList.forEach(texture =>{
                                    if(texture.id === tmpJSON.id){
                                        if(tmpJSON.value){
                                           return texture.isinterfacedefault = selectedTexture ? 1:0;          
                                        }else{
                                           return texture.isinterfacedefault = 0
                                        }
                                    }
                                })
                            }
                        })
                    }
                })
            }    
        })
    }

    //2025-04-25 jazz, check if obsoleted need to show
    static isObsoletedNeedShow = ( id, obsoletedColumn ) =>{
        let result = false;

        for( let i = store.state.PlanInfo.SelectedItems.length - 1; i >= 0; i-- ){
            if( store.state.PlanInfo.SelectedItems[i][`${obsoletedColumn}Id`] != id ) continue;

            //2026-03-28 mae = temporary uncomment due to IsObsoleted property not available in PlanInfo 
            // if( !store.state.PlanInfo.SelectedItems[i][`${obsoletedColumn}IsObsoleted`] ) continue;

            result = true;        
        }

        return result;
    }
	
    //2026-03-30 mae added. Display if the obsoleted selected item Completed
    static isSelectedObsoletedItemCountComplete( tmpObject, ColumnName ){
        let result = false

        if( tmpObject.obsoleteddate && (this.isObsoletedNeedShow( tmpObject.id, ColumnName )  ) ){
            result = true;
        }

        return result;
    }
	
     //added mae 2026-09-28
    static isHideItem(selectedItem, categoryObject, columname) {
        // const debug = columname === 'texture' && String(categoryObject.id) === '4126';

        // if (debug) {
        //     console.log('4126 texture object:', JSON.parse(JSON.stringify(categoryObject)));
        //     console.log('isdisplayed:', categoryObject.isdisplayed, typeof categoryObject.isdisplayed);
        //     console.log('selectedItem is array:', Array.isArray(selectedItem), 'length:', selectedItem?.length);
        //     console.log('matches in SelectedItems (any field):',
        //         (selectedItem || []).filter(i => Object.values(i).some(v => String(v) === '4126')));
        // }

        if (!Array.isArray(selectedItem) || Number(categoryObject.isdisplayed) !== 0) {
            // if (debug) console.log('4126: early return false (not array or isdisplayed != 0)');
            return false;
        }

        const fieldMap = {
            category: 'CategoryId',
            texture: 'TextureId'   // ← change to the real field name in SelectedItems
        };

        const field = fieldMap[columname];
        if (!field) {
            // if (debug) console.log('4126: unknown columname', columname);
            return false;
        }

        const match = selectedItem.find(
            item => String(item[field]) === String(categoryObject.id)
        );

        // if (debug) {
        //     console.log('4126: compared field', field, '→ match:', match, '→ result:', !!match);
        // }

        return !!match;
    }

     //added mae 2026-09-28
    static isHideItem(selectedItem, categoryObject, columname) {
        // const debug = columname === 'texture' && String(categoryObject.id) === '4126';

        // if (debug) {
        //     console.log('4126 texture object:', JSON.parse(JSON.stringify(categoryObject)));
        //     console.log('isdisplayed:', categoryObject.isdisplayed, typeof categoryObject.isdisplayed);
        //     console.log('selectedItem is array:', Array.isArray(selectedItem), 'length:', selectedItem?.length);
        //     console.log('matches in SelectedItems (any field):',
        //         (selectedItem || []).filter(i => Object.values(i).some(v => String(v) === '4126')));
        // }

        if (!Array.isArray(selectedItem) || Number(categoryObject.isdisplayed) !== 0) {
            // if (debug) console.log('4126: early return false (not array or isdisplayed != 0)');
            return false;
        }

        const fieldMap = {
            category: 'CategoryId',
            texture: 'TextureId'   // ← change to the real field name in SelectedItems
        };

        const field = fieldMap[columname];
        if (!field) {
            // if (debug) console.log('4126: unknown columname', columname);
            return false;
        }

        const match = selectedItem.find(
            item => String(item[field]) === String(categoryObject.id)
        );

        // if (debug) {
        //     console.log('4126: compared field', field, '→ match:', match, '→ result:', !!match);
        // }

        return !!match;
    }

    static filteredUserInterface = (ItemsArr, userSheet) =>{
        function generateSortFn(props) {
            return function (a, b) {
                for (var i = 0; i < props.length; i++) {
                    var prop = props[i];
                    var name = prop.name;
                    var reverse = prop.reverse;
                    if (a[name] < b[name])
                        return reverse ? 1 : -1;
                    if (a[name] > b[name])
                        return reverse ? -1 : 1;
                }
                return 0;
            };
        };
		
        function transformHeatingEquipmentTextureName( texturename ){
            const newContent = "パナソニック (" + texturename + ") ";
            return newContent;
        };

        let triggeredItemShown       = [];
		let triggeredSubCatItemShown = [];
		let triggeredSubIsTexture    = [];
        let triggeredTexture         = [];
		let triggeredItemID = null; //Added Mae 2026-09-04
		let hideItemIDcollector 	 = [];
		
		//Added Mae 2026-09-04
		const selectedItems = store.state.PlanInfo.SelectedItems;
		const isCopyPlan = store.state.PlanInfo.CopyPlan;
		
		const indicesToRemoveObsoletedItem = []; //mae added 2025-08-20

        try{
            for( let maincategory of ItemsArr ){
                if( maincategory.masterid == this.Const.SETSUBI_MASTER ){
                    if( this.Const.SINGLE_FLOORING_INTERFACE.includes(this.HouseTypeNumber()) ){
                        if( maincategory.id == this.Const.FIRST_FLOOR_ID ){
                            maincategory.items = maincategory.items.substring(2).trim()
                        }
                    }
                }
				
                //2026-03-28 mae revised ( display only the obsoleted item upon fetching) == Gaibu, Setsubi and Kihon
                if( maincategory.obsoleteddate){
    
                    //2026-03-31 mae added. temporary only. for deletion once the item officially obsoleted
                    if( maincategory.id == 2503 && this.Const.OBSOLETED_IN_HOUSETYPE.includes(this.HouseTypeNumber()) ){ 
                        maincategory.obsoleteddate = null;
                    }//=====

                    if( !this.isObsoletedNeedShow( maincategory.id, 'MainCategory' )){
                        if( !this.Const.OBSOLETED_IN_HOUSETYPE.includes(this.HouseTypeNumber())) { //2026-03-31 mae added. temporary only. for deletion once the item officially obsoleted
                            let newItem = maincategory.category.filter(item => {if(this.isObsoletedNeedShow(item.id, 'Category')){return item}});

                            if( newItem.length == 0 ){
                                const indexToRemove = ItemsArr.indexOf(maincategory);
                                if (indexToRemove !== -1) {
                                    indicesToRemoveObsoletedItem.push(indexToRemove);
                                } 
                            }
                        }
                    }                          
                }	
				

                let needToCompleteCount = 0 //2023-11-20
                let tmpArr2 = []; //temp, use for debugging 2025-05-13 jazz

                if( Array.isArray(maincategory.sortno) ){
                    maincategory.sortno.forEach(sortObj =>{
                        if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                            maincategory.sortno = sortObj.sortno;  
                        }
                    })
                } 

                //for comment
                if( Array.isArray(maincategory.comment) ){
                    let tmpMaincategoryComment = [];

                    maincategory.comment.forEach( commentObj =>{
                        if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                            if( commentObj.color ){
                                tmpMaincategoryComment.push(commentObj);
                                
                            }else{   
                                tmpMaincategoryComment.push(commentObj.comment);   
                            }
                        }
                    })

                    maincategory.comment = tmpMaincategoryComment;
                }        
 
                let tmpDuplicate      = [];

                if( maincategory.interfacedefaulthousetype ){
                    if( store.state.PlanInfo.CopyPlan == false && store.state.PlanInfo.isPrevious == false ){
                        if( maincategory.interfacedefaulthousetype.includes(parseInt(this.HouseTypeNumber())) ){
                            maincategory.isdefaultshown = true;
                        }else{
                            maincategory.isdefaultshown = false;
                        }
                    }else{
						//copy plan
                        const isItemExists = store.state.PlanInfo.SelectedItems.some( ele => ele.MainCategoryName === maincategory.items );

                        if( isItemExists ){
                           maincategory.isdefaultshown = true;   
                        }else{
							//edited by mae 2024-05-07 => to set the item visible in kihon
                            if( maincategory.masterid == this.Const.KIHON_MASTER && maincategory.id ){
                                maincategory.isdefaultshown = true;
                            }else{
                                maincategory.isdefaultshown = false;
                            } 
                        }
                    }
                }else{
                    maincategory.isdefaultshown = true;
                }

                if( maincategory.category ){  
                    maincategory.category = this.itemFilter( maincategory.category )

                    for( let categoryitem of maincategory.category ){
						
                         //added mae 2026-09-28
                        if(categoryitem.isdisplayed == 0){
                            if (this.isHideItem(store.state.PlanInfo.SelectedItems, categoryitem, 'category')){
                                categoryitem.isinterfacedefault = 1;
								hideItemIDcollector.push(categoryitem.id, );
                            }else{
                                categoryitem.isinterfacedefault = 0;
                            }
                        }
						
                        //2026-03-31 mae added. temporary only. for deletion once the item officially obsoleted
                        if( [2641, 2639].includes(categoryitem.id) && this.Const.OBSOLETED_IN_HOUSETYPE.includes(this.HouseTypeNumber()) ){ 
                            categoryitem.obsoleteddate = null;
                        }//=	
						
                        //for completed 2023-11-20
                        if( categoryitem.id !== this.Const.BUILDING_SITE ){
                            //2023-11-22
                            if( categoryitem.ischeckbox === 0 ){
                                if( (categoryitem.isinterfacedefault == 1 && !categoryitem.obsoleteddate) || 
                                    (categoryitem.isinterfacedefault == 1 && this.isSelectedObsoletedItemCountComplete( categoryitem, 'Category') )  //2026-04-02 added mae
                                    ){
                                    needToCompleteCount = needToCompleteCount + 1
                                          
                                    //2025-05-13 jazz, use for debugging
                                    tmpArr2.push('a. ' + categoryitem.items + ' == ' + !categoryitem.obsoleteddate )
                                }
                            }

                            if( categoryitem.ischildselection === 1 ){
                                if( (categoryitem.isinterfacedefault == 1 && !categoryitem.obsoleteddate ) || 
                                     (categoryitem.isinterfacedefault == 1 && this.isSelectedObsoletedItemCountComplete( categoryitem, 'Category'))  ){ //2026-04-02 added mae
                                    needToCompleteCount = needToCompleteCount - 1

                                    //2025-05-13 jazz, use for debugging
                                    const tmpidx = tmpArr2.findIndex( item => item == categoryitem.items )
                                    tmpArr2.splice(tmpidx, 1);
                                }
                            }
                        }

                        if( Array.isArray(categoryitem.sortno) ){
                            categoryitem.sortno.forEach( sortObj =>{
                                if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                    categoryitem.sortno = sortObj.sortno;  
                                }
                            })
                        }  
						
						//Added Mae 2026-09-04
                        //const selectedItems = store.state.PlanInfo.SelectedItems;
                        //const isCopyPlan = store.state.PlanInfo.CopyPlan;
                        //const findNeedToHide = selectedItems.find(obj => ( obj.CategoryId === 4876 || obj.CategoryId === 171 ) );
                        
                        //if (findNeedToHide && isCopyPlan === true) {
                        //    triggeredItemID = 415101; 
                        //}else if((findNeedToHide && store.state.PlanInfo.isPrevious == "shiyocompleted")) {
                        //    triggeredItemID = 415101; 
                        //}else if((findNeedToHide && store.state.PlanInfo.isPrevious == true)) {
                        //    triggeredItemID = 415101; 
                        //}						

                        //for category comment
                        if( Array.isArray(categoryitem.comment) ){
                            let tmpCategoryComment = [];

                            categoryitem.comment.forEach( commentObj =>{
                                if( commentObj.houseapplicable.includes( this.HouseTypeNumber()) ){
                                    if( commentObj.color ){
                                        tmpCategoryComment.push(commentObj);
                                        
                                    }else{   
                                        tmpCategoryComment.push(commentObj.comment);   
                                    }
                                }
                            })

                            categoryitem.comment = tmpCategoryComment;
                        } 
 
                        //2025-05-07 jazz
                        let isMultipleCategoryShown = false;

                        if( maincategory.masterid == this.Const.SETSUBI_MASTER && [this.Const.TOILET_1F_ID, this.Const.TOILET_2F_ID, this.Const.TOILET_3F_ID].includes(categoryitem.parentid) ){
                            if( /(?:\(\d\)$)/.test(categoryitem.items) ){
                                isMultipleCategoryShown = store.state.PlanInfo.SelectedItems.some( ele => ele.MainCategoryName === maincategory.items && ele.CategoryName == categoryitem.items );

                                if( isMultipleCategoryShown ){
                                    categoryitem.isinterfacedefault = 1;
                                }
                            }
                        } 

                        //added by mae show/hide texture
                        //mae 2024-11-19
                        if( (triggeredTexture.includes(categoryitem.id) && !categoryitem.obsoleteddate )|| 
                            ( triggeredTexture.includes(categoryitem.id) && this.isSelectedObsoletedItemCountComplete( categoryitem, 'Category')) //2026-04-02 added mae
                            ){
                            categoryitem.isinterfacedefault = 1
                            // needToCompleteCount = needToCompleteCount + 1 

                            //2025-05-13 jazz, use for debugging
                            tmpArr2.push('b. ' + categoryitem.items+ ' == ' + this.isObsoletedNeedShow(categoryitem.id, 'Category'))
                        }

                        if ( categoryitem.subcategory ){
                            categoryitem.subcategory = this.itemFilter( categoryitem.subcategory )

                            for( let subcategoryitem of categoryitem.subcategory ){
                                //2025-05-07 jazz
                                if( isMultipleCategoryShown ){
                                    subcategoryitem.isinterfacedefault = 1;      
                                } 
								
                                //added 2024-10-07 ==Custom Change the Item name==
                                if( subcategoryitem.masterid == this.Const.SETSUBI_MASTER ){
                                    if( this.Const.CHECK_HOUSE_TYPE.includes(this.HouseTypeNumber()) ){
                                        if( subcategoryitem.id == this.Const.SYSTEM_KITCHEN_HANGING_CUPBOARD_ID ){
                                            subcategoryitem.items = subcategoryitem.items.split('・')[2];
                                        }
                                    }
                                }

                                // if( subcategoryitem.masterid == this.Const.GAIBU_MASTER ){
                                //     if( this.Const.CHECK_HOUSE_TYPE.includes(this.HouseTypeNumber()) ){  
                                //         //mae added 2025-09-01  
                                //         const updateName = (item, nameKey, itemName) => {
                                //             item[nameKey] = itemName;
                                //         };
                                        
                                //         if(this.Const.GENKAN_DOOR_TYPE_ID.includes(subcategoryitem.id)) {
                                //             updateName(subcategoryitem, 'items', this.Const.GENKAN_DOOR_TYPE_LABEL);
                                //         }
                                        
                                //         const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.SubcategoryId === subcategoryitem.id);
                                //         if(findItem && this.Const.GENKAN_DOOR_TYPE_ID.includes(findItem.SubcategoryId)) {
                                //             updateName(findItem, 'SubcategoryName', this.Const.GENKAN_DOOR_TYPE_LABEL);
                                //         }

                                //     }
                                // }
								
                                //2023-11-21                            ==added mae 2025-05-09==
                                if( subcategoryitem.ischeckbox === 0 && subcategoryitem.parentid !== this.Const.MONOHOSHI){
                                    if( subcategoryitem.isinterfacedefault == 1 ){
                                        needToCompleteCount = needToCompleteCount + 1 

                                        //2025-05-13 jazz, use for debugging
                                        tmpArr2.push('c. ' + subcategoryitem.items+ ' == ' + this.isObsoletedNeedShow(subcategoryitem.id, 'Category'))   
                                    }
                                }
 
                                if( subcategoryitem.ischildselection === 1 ){
                                    if( (subcategoryitem.isinterfacedefault == 1 && !subcategoryitem.obsoleteddate) ||
                                        (subcategoryitem.isinterfacedefault == 1 && this.isSelectedObsoletedItemCountComplete( subcategoryitem, 'Subcategory')) //2026-04-02 added mae
                                        ){
                                        needToCompleteCount = needToCompleteCount - 1

                                        //2025-05-13 jazz, use for debugging
                                        const tmpidx = tmpArr2.findIndex( item => item == subcategoryitem.items )
                                        tmpArr2.splice(tmpidx, 1);
                                    }    
                                }

                                if( Array.isArray(subcategoryitem.sortno) ){
                                    subcategoryitem.sortno.forEach( sortObj =>{
                                        if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                            subcategoryitem.sortno = sortObj.sortno;  
                                        }
                                    })
                                } 

                                if( subcategoryitem.trigger_to_id ){
                                    //mae 2024-11-19
                                    let tmpArray = this.isDisplayTriggeredItem(JSON.parse(subcategoryitem.trigger_to_id));

                                    tmpArray.forEach( tmpJSON => {
                                        if( tmpJSON.value ){
                                            const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.SubcategoryId == subcategoryitem.id);
    
                                            if( findItem ){
                                                const isAlreadyAdded = triggeredSubIsTexture.find(obj => obj == tmpJSON.id);

                                                if( !isAlreadyAdded ){
                                                    triggeredSubIsTexture.push(tmpJSON.id) 
                                                }     
                                            }
                                        }
                                    })
                                }                                

                                //for subcategory comment
                                if( Array.isArray(subcategoryitem.comment) ){
                                    let tmpSubcategoryComment = [];

                                    subcategoryitem.comment.forEach( commentObj =>{
                                        if( commentObj.houseapplicable.includes( this.HouseTypeNumber()) ){
                                            if( commentObj.color ){
                                                tmpSubcategoryComment.push( commentObj );
                                                
                                            }else{   
                                                tmpSubcategoryComment.push( commentObj.comment );   
                                            }
                                        }
                                    })

                                    subcategoryitem.comment = tmpSubcategoryComment;
                                }

                                if ( subcategoryitem.specs ) {
                                    subcategoryitem.specs = this.itemFilter(subcategoryitem.specs)

                                    for( let specsitem of subcategoryitem.specs ){

                                        //2023-11-22
                                        if( specsitem.ischeckbox === 0 && specsitem.ischildselection !== 1 ){
                                            if( (specsitem.isinterfacedefault == 1 && !specsitem.obsoleteddate) ||
                                                (specsitem.isinterfacedefault == 1 && this.isSelectedObsoletedItemCountComplete( specsitem, 'Specs') ) //2026-04-02 added mae
                                                ){
                                                needToCompleteCount = needToCompleteCount + 1 

                                                //2025-05-13 jazz, use for debugging
                                                tmpArr2.push('d. ' + specsitem.items+ ' == ' + this.isObsoletedNeedShow(specsitem.id, 'Specs'))   
                                            }  
                                        }

                                        if( specsitem.ischildselection === 1 ){
                                            if( (specsitem.isinterfacedefault == 1 && !specsitem.obsoleteddate) ||
                                                (specsitem.isinterfacedefault == 1 && this.isSelectedObsoletedItemCountComplete( specsitem, 'Specs')) //2026-04-02 added mae
                                                ){
                                                needToCompleteCount = needToCompleteCount - 1

                                                //2025-05-13 jazz, use for debugging
                                                const tmpidx = tmpArr2.findIndex( item => item == specsitem.items )
                                                tmpArr2.splice(tmpidx, 1);     
                                            }
                                        }

                                        //for specs sort
                                        if( Array.isArray(specsitem.sortno) ){
                                            specsitem.sortno.forEach(sortObj =>{
                                                if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                                    specsitem.sortno = sortObj.sortno;  
                                                }
                                            })
                                        } 

                                        //for specs comment
                                        if( Array.isArray(specsitem.comment) ){
                                            let tmpSpecsComment = [];

                                            specsitem.comment.forEach( commentObj =>{
                                                if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                                    if( commentObj.color ){
                                                        tmpSpecsComment.push(commentObj);
                                                    }else{   
                                                        tmpSpecsComment.push(commentObj.comment);   
                                                    }
                                                }
                                            })

                                            specsitem.comment = tmpSpecsComment;
                                        }

                                        if ( specsitem.textureList ) {
                                            specsitem.textureList = this.itemFilter( specsitem.textureList )

                                            specsitem.textureList.forEach( texture =>{
                                                if( Array.isArray(texture.sortno) ){
                                                    texture.sortno.forEach(sortObj =>{
                                                        if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                                            texture.sortno = sortObj.sortno;  
                                                        }
                                                    })
                                                }

                                                if( Array.isArray(texture.comment) ){
                                                    let tmpTextureComment = [];

                                                    texture.comment.forEach( commentObj =>{
                                                        if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                                            if( commentObj.color){
                                                                tmpTextureComment.push( commentObj );
                                                            }else{   
                                                                tmpTextureComment.push( commentObj.comment );   
                                                            }
                                                        }
                                                    })

                                                    texture.comment = tmpTextureComment;
                                                }

                                                //added by mae show/hide texture
                                                if( texture.trigger_to_id ){
                                                    // const tmpJSON = JSON.parse(texture.trigger_to_id)

                                                    //mae 2024-11-19
                                                    let tmpArray = this.isDisplayTriggeredItem( JSON.parse(texture.trigger_to_id) );

                                                    tmpArray.forEach( tmpJSON => {
														
                                                        //Added Mae 2026-09-04
                                                        if(tmpJSON.id == triggeredItemID){
                                                            tmpJSON.value = false;
                                                        }	
														
                                                        if( tmpJSON.value ){
                                                            const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.TextureId == texture.id);
                    
                                                            if( findItem ){
                                                                const isAlreadyAdded = triggeredTexture.find(obj => obj == tmpJSON.id);
																const isAlreadyAddedCategoryItem = triggeredItemShown.find(obj => obj == tmpJSON.id); //added mae 2026-02-03
																
                                                                if( !isAlreadyAdded ){
                                                                    triggeredTexture.push(tmpJSON.id) 
                                                                }   
																
                                                                if( !isAlreadyAddedCategoryItem ){ //added mae 2026-02-03
                                                                    triggeredItemShown.push(tmpJSON.id) 
                                                                } 	
                                                            }
                                                        }
                                                    })
                                                }
                                                
                                                for ( var i = store.state.PlanInfo.SelectedItems.length - 1; i >= 0; i-- ){
                                                    if( texture.isinterfacedefault === 0 ){
                                                        if( store.state.PlanInfo.SelectedItems[i].TextureName === texture.texturename ){
                                                            texture.isinterfacedefault = 1
                                                        }
                                                    }
                                                } 
                                            })

                                            //2025-04-25 jazz, include obsoleted when selected in previous only
                                            specsitem.textureList = specsitem.textureList.filter( item =>{
												
                                                if( this.isObsoletedNeedShow( item.id, 'Texture' ) || !item.obsoleteddate ){
                                                    return item;
                                                }
												
                                                //2026-03-28 added mae
                                                if( this.isObsoletedNeedShow( specsitem.id, 'Specs' ) && specsitem.obsoleteddate){
                                                    if( this.isObsoletedNeedShow( item.folderid, 'Specs' ) && item.obsoleteddate ){ 
                                                        return item;
                                                    }
                                                }
												
                                            }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                                            //specsitem.textureList.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
                                        }

                                        if( specsitem.isunchecktextures == 0 && specsitem.istexture == 1 ){
                                           tmpDuplicate.push( specsitem.parentid )    
                                        } 
                                    }

                                    //2025-04-25 jazz, include obsoleted when selected in previous only
                                    subcategoryitem.specs = subcategoryitem.specs.filter( item =>{
										
                                        if( this.isObsoletedNeedShow( item.id, 'Specs' ) || !item.obsoleteddate ){
                                            return item;
                                        }
										
                                        //2026-03-28 added mae
                                        if( this.isObsoletedNeedShow( subcategoryitem.id, 'Subcategory' ) && subcategoryitem.obsoleteddate){
                                            if( this.isObsoletedNeedShow( item.parentid, 'Subcategory' ) && item.obsoleteddate ){ 
                                                return item;
                                            }
                                        }
										
                                    }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                                    //subcategoryitem.specs.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz 
                                }

                                if( subcategoryitem.textureList ){
                                    subcategoryitem.textureList = this.itemFilter(subcategoryitem.textureList) 

                                    subcategoryitem.textureList.forEach( texture =>{
                                        if( Array.isArray(texture.sortno) ){
                                            texture.sortno.forEach(sortObj =>{
                                                if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                                                    texture.sortno = sortObj.sortno;  
                                                }
                                            })
                                        }
										
                                        //added mae 2025-02-04 ==Custom Change the Item name ( grandsmart, i-smart, i-smart(３階建）, i-cube III )==
                                        if( texture.masterid == this.Const.SETSUBI_MASTER ){
                                            if( !this.Const.CHECK_HOUSE_TYPE.includes(this.HouseTypeNumber()) ){
                                                const updateName = (item, nameKey) => {
                                                    const match = item[nameKey].match(/(IH：)(.*?)(\s*K.*)/);
                                                    if (match) {
                                                        item[nameKey] = `${match[1]}${transformHeatingEquipmentTextureName(match[2])}${match[3]}`;
                                                    }
                                                };
                                            
                                                if( this.Const.SYSTEM_KITCHEN_HEATING_EQUIPMENT_ID.includes(texture.id) ){
                                                    updateName(texture, 'texturename');
                                                }
                                            
                                                const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.TextureId === texture.id);
                                                if ( findItem && this.Const.SYSTEM_KITCHEN_HEATING_EQUIPMENT_ID.includes(findItem.TextureId) ) {
                                                    updateName(findItem, 'TextureName');
                                                }

                                            }   
                                        }

                                        if( Array.isArray(texture.comment) ){
                                            let tmpTextureComment = [];

                                            texture.comment.forEach( commentObj =>{
                                                if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                                    if( commentObj.color ){
                                                        tmpTextureComment.push( commentObj );
                                                    }else{   
                                                        tmpTextureComment.push( commentObj.comment );   
                                                    }
                                                }
                                            })

                                            texture.comment = tmpTextureComment;
                                        }

										//added by mae show/hide texture (for terrasu)
										if( texture.trigger_to_id ){
											// const tmpJSON = JSON.parse(texture.trigger_to_id)

                                            //mae 2024-11-19
                                            let tmpArray = this.isDisplayTriggeredItem( JSON.parse(texture.trigger_to_id) );

                                            tmpArray.forEach( tmpJSON => {
                                                if( tmpJSON.value ){
                                                    const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.TextureId == texture.id);
            
                                                    if(findItem){
                                                        const isAlreadyAdded = triggeredSubCatItemShown.find(obj => obj == tmpJSON.id);
                                                        
                                                        if( !isAlreadyAdded ){
                                                            triggeredSubCatItemShown.push(tmpJSON.id) 
                                                        }     
                                                    }
                                                }
                                            })
										}
                                         
                                        for ( var i = store.state.PlanInfo.SelectedItems.length - 1; i >= 0; i-- ) {
                                            //2025-05-19 jazz, add condition for trigger, revise all loop for trigger_texture
                                            if( store.state.PlanInfo.SelectedItems[i].MasterId !== maincategory.masterid ) continue;
                                            if( store.state.PlanInfo.SelectedItems[i].MainCategoryName !== maincategory.items ) continue;
                                            if( store.state.PlanInfo.SelectedItems[i].CategoryName !== categoryitem.items ) continue;
                                            if( store.state.PlanInfo.SelectedItems[i].SubcategoryName !== subcategoryitem.items ) continue;
                                            if( store.state.PlanInfo.SelectedItems[i].TextureName !== texture.texturename ) continue;
                                            if( texture.isinterfacedefault != 0 ) continue;

                                            texture.isinterfacedefault = 1
                                        }     
                                    })

                                    //2025-04-25 jazz, include obsoleted when selected in previous only
                                    subcategoryitem.textureList = subcategoryitem.textureList.filter( item =>{
										
                                        if( this.isObsoletedNeedShow( item.id, 'Texture' ) || !item.obsoleteddate ){
                                            return item;
                                        }
										
                                        //2026-03-28 added mae
                                        if( this.isObsoletedNeedShow( subcategoryitem.id, 'Subcategory' ) && subcategoryitem.obsoleteddate){
                                            if( this.isObsoletedNeedShow( item.folderid, 'Subcategory' ) && item.obsoleteddate ){ 
                                                return item;
                                            }
                                        }	
										
                                    }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                                    //subcategoryitem.textureList.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
                                }

                                if( subcategoryitem.isunchecktextures == 0 && subcategoryitem.istexture == 1){
                                    tmpDuplicate.push(subcategoryitem.parentid)    
                                }
                            }

                            //2025-04-25 jazz, include obsoleted when selected in previous only
                            categoryitem.subcategory = categoryitem.subcategory.filter(item =>{
								
                                if( this.isObsoletedNeedShow( item.id, 'Subcategory' ) || !item.obsoleteddate ){
                                    return item;
                                }
								
								//2026-03-28 added mae
								if( this.isObsoletedNeedShow( categoryitem.id, 'Category' ) && categoryitem.obsoleteddate){
									if( this.isObsoletedNeedShow( item.parentid, 'Category' ) && item.obsoleteddate ){ 
										return item;
									}
								} 
								
                            }).sort(generateSortFn([{name: 'sortno', reverse: false}]));
                            
                            // categoryitem.subcategory.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz 
                        }

                        if( categoryitem.textureList ){
                            categoryitem.textureList = this.itemFilter( categoryitem.textureList )  

                            categoryitem.textureList.forEach( texture =>{
								
                                //2026-03-31 mae added. temporary only. for deletion once the item officially obsoleted
                                if( [2641, 2639].includes(texture.folderid) && this.Const.OBSOLETED_IN_HOUSETYPE.includes(this.HouseTypeNumber()) ){ 
                                    texture.obsoleteddate = null;
                                }//=  


                                //2026-09-05 mae added. temporary only
                                if( [2874, 2878].includes(texture.folderid) && 
                                    ( texture.datedeleted == null ) && 
                                    (texture.obsoleteddate != null) &&
                                    (isCopyPlan || store.state.PlanInfo.CurrentMenu !== "作成(Create)") ){ 
                                        texture.obsoleteddate = null;
                                }//==    


                                //added line 2024-01-23 jazz
                                if( texture.trigger_to_id ){
                                    // const tmpJSON = JSON.parse(texture.trigger_to_id)

                                    //mae 2024-11-19 (toggle function)
                                    let tmpArray = this.isDisplayTriggeredItem(JSON.parse(texture.trigger_to_id));

                                    tmpArray.forEach( tmpJSON => {
                                        if( tmpJSON.value ){
                                            const findItem = store.state.PlanInfo.SelectedItems.find(obj => obj.TextureId == texture.id);
    
                                            if( findItem ){
                                                const isAlreadyAdded = triggeredItemShown.find(obj => obj == tmpJSON.id);

                                                if( !isAlreadyAdded ){
                                                    triggeredItemShown.push(tmpJSON.id) 
                                                }     
                                            }
                                        }
                                    })
                                }

                                if(Array.isArray(texture.sortno)){
                                    texture.sortno.forEach(sortObj =>{
                                        if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                                            texture.sortno = sortObj.sortno;  
                                        }
                                    })
                                }

                                if( Array.isArray(texture.comment) ){
                                    let tmpTextureComment = [];

                                    texture.comment.forEach( commentObj =>{
                                        if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                            if( commentObj.color ){
                                                tmpTextureComment.push( commentObj );
                                            }else{   
                                                tmpTextureComment.push( commentObj.comment );   
                                            }
                                        }
                                    })

                                    texture.comment = tmpTextureComment;
                                }
								
                                 //added mae 2026-09-28
                                if (Number(texture.isdisplayed) === 0) {
                                    if (this.isHideItem(store.state.PlanInfo.SelectedItems, texture, 'texture')) {
                                        texture.isinterfacedefault = 1;   // in SelectedItems → show
                                    } else {
                                        texture.isinterfacedefault = 0;   // not in SelectedItems → hide
                                    }
                                }

                                 //added mae 2026-09-28
                                if (Number(texture.isdisplayed) === 0) {
                                    if (this.isHideItem(store.state.PlanInfo.SelectedItems, texture, 'texture')) {
                                        texture.isinterfacedefault = 1;   // in SelectedItems → show
                                    } else {
                                        texture.isinterfacedefault = 0;   // not in SelectedItems → hide
                                    }
                                }

                                for ( var i = store.state.PlanInfo.SelectedItems.length - 1; i >= 0; i-- ) {
                                    if( texture.isinterfacedefault === 0 ){
                                        if( store.state.PlanInfo.SelectedItems[i].TextureName === texture.texturename ){
                                            texture.isinterfacedefault = 1
                                        }
                                    }
									
									//added mae 2026-10-01
									if(hideItemIDcollector.includes(texture.folderid) && texture.isdisplayed === 1){
                                        if ( store.state.PlanInfo.SelectedItems[i].CategoryId == texture.folderid) {
											if(texture.id === store.state.PlanInfo.SelectedItems[i].TextureId){
												texture.isinterfacedefault = 1;
											}else{
												texture.isinterfacedefault = 0;
											}	
                                        }
									}
									
                                     //added mae 2026-09-28
                                    if ( texture.isdisplayed === 0 ) {
                                        if ( store.state.PlanInfo.SelectedItems[i].CategoryId == texture.folderid) {
											if(texture.id === store.state.PlanInfo.SelectedItems[i].TextureId){
												texture.isinterfacedefault = 1;
											}else{
												texture.isinterfacedefault = 0;
											}	
                                        }
                                    }
									
                                    //Added mae 2026-09-05 temporary only
                                    if( isCopyPlan || store.state.PlanInfo.CurrentMenu !== "作成(Create)" ){
                                        if( [2874, 2878].includes(store.state.PlanInfo.SelectedItems[i].TextureParentId) &&
                                        (store.state.PlanInfo.SelectedItems[i].TextureIsObsoleted != null)  &&
                                        (store.state.PlanInfo.SelectedItems[i].TextureId == texture.id)
                                        ){
                                            store.state.PlanInfo.SelectedItems[i].TextureIsObsoleted = null;
                                        }
                                    }	
                                } 
                            })

                            //2025-04-25 jazz, include obsoleted when selected in previous only
                            categoryitem.textureList = categoryitem.textureList.filter(item =>{
								
                                if( this.isObsoletedNeedShow( item.id, 'Texture' ) || !item.obsoleteddate ){
                                    return item;
                                }
								
                                //2026-03-28 added mae
                                if( this.isObsoletedNeedShow( categoryitem.id, 'Category' ) && categoryitem.obsoleteddate){
                                    if( this.isObsoletedNeedShow( item.folderid, 'Category' ) && item.obsoleteddate ){ 
                                        return item;
                                    }
                                }
								
                            }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                            // categoryitem.textureList.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
                        }
                    }

                    //added line 2024-01-24
                    maincategory.category.forEach(item =>{
                        if( (triggeredItemShown.includes(item.id) && !item.obsoleteddate) ||
                            ( triggeredItemShown.includes(item.id) && this.isSelectedObsoletedItemCountComplete( item, 'Category') ) //2026-04-02 added mae
                            ){
                            item.isinterfacedefault = 1;
                            needToCompleteCount = needToCompleteCount + 1

                            //2025-05-13 jazz, use for debugging
                            tmpArr2.push('3. ' + item.items + '=>' + item.id)
                        }
						
						//terrasu
                        if( (triggeredSubCatItemShown.includes(item.id) && !item.obsoleteddate) ||
                            ( triggeredSubCatItemShown.includes(item.id) && this.isSelectedObsoletedItemCountComplete( item, 'Category') ) //2026-04-02 added mae
                            ){
                            item.isinterfacedefault = 1;		
							needToCompleteCount = needToCompleteCount + 1

                            //2025-05-13 jazz, use for debugging
                            tmpArr2.push('f. ' +item.items+ '=>' + item.id)
                        }

                        if(triggeredSubIsTexture.includes(item.id)){ //mae optimized 2025-08-29   
                            item.isinterfacedefault = 1;		
                            needToCompleteCount = needToCompleteCount + 1 

                            if(item.obsoleteddate && !this.isObsoletedNeedShow( item.id, 'Category' )){
                                item.isinterfacedefault = 0;		
                                needToCompleteCount = needToCompleteCount - 1 
                            }

                            //2025-05-13 jazz, use for debugging
                            tmpArr2.push('a. ' + item.items+ '=>' + item.id)
                        }
						
                        //2025-04-07 added mae for subcategory texture toggle
                        if(item.subcategory){
                            item.subcategory.forEach( item => {
 
                                if(item.textureList){
                                    item.textureList.forEach(texture => {
                                        if( triggeredTexture.includes(texture.id) ){
                                            texture.isinterfacedefault = 1;
                                        }
										
                                        if( triggeredSubCatItemShown.includes(texture.id) ){
                                            texture.isinterfacedefault = 1;
                                        }
										
                                    })
                                }
                            })
                        }
                    })

                    //2025-04-25 jazz, include obsoleted when selected in previous only
                    maincategory.category = maincategory.category.filter(item =>{
						
                        if( this.isObsoletedNeedShow( item.id, 'Category' ) || !item.obsoleteddate ){
                            return item;
                        }
						
                        //2026-03-28 added mae
                        if( this.isObsoletedNeedShow( maincategory.id, 'MainCategory' ) && maincategory.obsoleteddate){
                            if( this.isObsoletedNeedShow( item.parentid, 'MainCategory' ) && item.obsoleteddate ){ 
                                return item;
                            }
                        }
						
                    }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                    // maincategory.category.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
                }

                if( maincategory.textureList ){
                    maincategory.textureList = this.itemFilter(maincategory.textureList)

                    maincategory.textureList.forEach( texture =>{
                        if( Array.isArray( texture.sortno) ){
                            texture.sortno.forEach( sortObj =>{
                                if( sortObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                    texture.sortno = sortObj.sortno;  
                                }
                            })
                        }

                        if( Array.isArray(texture.comment) ){
                            let tmpTextureComment = [];

                            texture.comment.forEach( commentObj =>{
                                if( commentObj.houseapplicable.includes(this.HouseTypeNumber()) ){
                                    if( commentObj.color ){
                                        tmpTextureComment.push(commentObj);
                                    }else{   
                                        tmpTextureComment.push(commentObj.comment);   
                                    }
                                }
                            })

                            texture.comment = tmpTextureComment;
                        }
                    })

                    //2025-04-25 jazz, include obsoleted when selected in previous only
                    maincategory.textureList = maincategory.textureList.filter(item =>{
						
                        if( this.isObsoletedNeedShow( item.id, 'Texture' ) || !item.obsoleteddate ){
                            return item;
                        }
						
                        //2026-03-28 added mae
                        if( this.isObsoletedNeedShow( maincategory.id, 'MainCategory' ) && maincategory.obsoleteddate){
                            if( this.isObsoletedNeedShow( item.folderid, 'MainCategory' ) && item.obsoleteddate ){ 
                                return item;
                            }
                        }
						
                    }).sort(generateSortFn([{name: 'sortno', reverse: false}]));

                    // maincategory.textureList.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
                }

                maincategory.needtocompletecount = (needToCompleteCount > 0) ? needToCompleteCount:1

                //2026-10-21 jazz, 給水工事 allows multiple selections (see Category.vue/Textures.vue
                //2026-07-07 changes) - the count above ends up counting its available options (e.g. 5),
                //not how many must be picked. Pin it to 1 so "at least one selected" is what decides
                //completion (see the CheckItemIfCompleted/ReupdateCompletedHint overrides for this id).
                if(maincategory.id === this.Const.WATER_SUPPLY_CONST_ID){
                    maincategory.needtocompletecount = 1
                }

                //2025-05-13, jazz use for debugging
                // if( maincategory.id == 136 ){
                //     console.log(  maincategory.items + ' @@ ' + needToCompleteCount ) 
                //     console.log(tmpArr2) 
                // }

                maincategory.iscompleted = this.CheckItemIfCompleted(maincategory)
            }//end maincategory loopings
			
            //mae added 2025-08-20
            for (let index of indicesToRemoveObsoletedItem.reverse()) {
                    ItemsArr.splice(index, 1);
            }  

            ItemsArr.sort(generateSortFn([{name: 'sortno', reverse: false}])); //jazz
            store.dispatch(userSheet, ItemsArr );
        }catch(e){
            console.log(e)
        }
    }

    static SaveItemToStore = async (param) =>{
        const instance   = param.instance
        const columnname = param.columnname
        const itemArr    = param.itemArr
        const isclicked  = param.isclicked

        const tmpTextureArr = [
                                 null,
                                 this.SelectedDataObj( instance.filteredMaincategory, null, null, null, null, isclicked ), 
                                 this.SelectedDataObj( instance.filteredMaincategory, itemArr, null, null, null, isclicked ),
                                 this.SelectedDataObj( instance.filteredMaincategory, instance.filteredCategory, itemArr, null, null, isclicked ),
                                 this.SelectedDataObj( instance.filteredMaincategory, instance.filteredCategory, instance.filteredSubcategory, itemArr, null, isclicked )
                              ]

        let tmpTexture = {}

        if(itemArr.groupid === -1){
            tmpTexture = this.SelectedDataObj( instance.filteredMaincategory, instance.filteredCategory, instance.filteredSubcategory, instance.filteredSpecs, itemArr, isclicked );
        }else{
            tmpTexture = tmpTextureArr[itemArr.groupid];    
        }

        //2026-10-21 jazz, 給水工事's RowIndex is not stable across code paths: a texture picked by
        //clicking it computes RowIndex from the live component's filteredCategory, while
        //SetPreselected (plan-copy load) computes it by passing the category object directly - when
        //those two disagree on whether the category's id gets folded into RowIndex, a preloaded row's
        //RowIndex no longer matches what an uncheck click looks up, so the row is never found/removed.
        //Match on MainCategoryId+TextureId instead for this item, which is stable regardless of path.
        let itemIndex;

        const isWaterSupplyTexture = instance.filteredMaincategory && instance.filteredMaincategory.id === this.Const.WATER_SUPPLY_CONST_ID && columnname === 'Texture';

        if( isWaterSupplyTexture ){
            itemIndex = store.state.PlanInfo.SelectedItems.findIndex( e => e.MainCategoryId === this.Const.WATER_SUPPLY_CONST_ID && e.TextureId === itemArr.id )
        }else{
            itemIndex = store.state.PlanInfo.SelectedItems.map(e => e.RowIndex).indexOf( tmpTexture.RowIndex )
        }

        // const mainItemName = (this.SelectedDataObj( instance.filteredMaincategory, null, null, null, null, isclicked )).MainCategoryName
        // const tmpSameItemObj = (store.state.PlanInfo.SelectedItems.filter( item => item.MainCategoryName == mainItemName ))[0]

        // if(tmpTexture.MainCategoryName = '神棚'){

        //     console.log(mainItemName)
        //     console.log(tmpSameItemObj)   
        // }

        //2024-11-11 jazz
        // if( tmpTexture != '--' ){
        //     if( tmpTexture.MasterId == 2){
        //         tmpTexture.Floor = tmpSameItemObj.Floor
        //         tmpTexture.RoomName = tmpSameItemObj.RoomName
        //         tmpTexture.Hinban = tmpSameItemObj.Hinban
        //         tmpTexture.ItemNumber = tmpSameItemObj.ItemNumber
        //     }    
        // }

        if (instance[`selected${columnname}`]) {
             if (itemIndex == -1) {
                store.dispatch('AddToSelectedItems', tmpTexture)
            } else {
                const payload = { index: itemIndex, newvalue: tmpTexture }
                store.dispatch('UpdateSelectedItem', payload)
            }
        } else {

            //2026-10-21 jazz, 給水工事 can end up with duplicate rows for the same texture - one from
            //a copy-plan preload (SetPreselected), one from a live click - because those two paths
            //compute different RowIndex values for what is really the same selection. Removing a
            //single index (whichever the generic logic below happens to find first) leaves the
            //duplicate behind, so the completed-mark stays lit. Remove every row matching this
            //maincategory+texture instead, so unchecking always clears it completely.
            if( isWaterSupplyTexture ){
                for (let i = store.state.PlanInfo.SelectedItems.length - 1; i >= 0; i--) {
                    const row = store.state.PlanInfo.SelectedItems[i];

                    if( row.MainCategoryId === this.Const.WATER_SUPPLY_CONST_ID && row.TextureId === itemArr.id ){
                        store.dispatch('RemoveSelectedItem', i)
                    }
                }

                return;
            }

            if( itemArr.groupid > -1 ){
                store.dispatch('RemoveSelectedItem', itemIndex)
            } else {

                if( itemArr.isparentcheckbox == 1 ){
                    //for (const objprop in tmpTexture) {
                    tmpTexture[`${columnname}Name`] = null
                    tmpTexture[`${columnname}CategoryCode`] = null
                    tmpTexture[`${columnname}Comment`] = null
                    tmpTexture[`${columnname}Id`] = null
                    tmpTexture[`${columnname}Name`] = null
                    tmpTexture[`${columnname}ParentId`] = null
                    tmpTexture[`${columnname}SelectionId`] = null
                    tmpTexture[`${columnname}Sort`] = null
                    tmpTexture[`${columnname}ValueCode`] = null
                    tmpTexture[`${columnname}istexture`] = null
                    //}
                    const payload = { index: itemIndex, newvalue: tmpTexture }
                    store.dispatch('UpdateSelectedItem', payload)
                } else { 
                    store.dispatch('RemoveSelectedItem', itemIndex)
                }
            }
        }
    }

    // //2025-08-08 jazz
    // static SetToiletAndSystemBathNeedToCompleteCount = async ( maincategoryObj, categoryObj ) =>{
    //     try{
    //         let needToCompleteCount = 0

    //         if(categoryObj.subcategory){
    //             for (var i = categoryObj.subcategory.length - 1; i >= 0; i--) {
    //                 if(categoryObj.subcategory[i].ischildselection !== 1){
    //                     needToCompleteCount++
    //                 }else{
    //                     if(categoryObj.subcategory[i].specs){
    //                         needToCompleteCount = needToCompleteCount + categoryObj.subcategory[i].specs.filter(item => item.ischeckbox === 0).length
    //                     }
    //                 }
    //             }
    //         }
 
    //         let addCount = 0;

    //         for(let i = 0; i < maincategoryObj.category.length; i++){
    //             if(!this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(maincategoryObj.category[i].id)) continue;
    //             if(maincategoryObj.category[i].isinterfacedefault != 1) continue;
         
    //             addCount++
    //         }
 
    //         needToCompleteCount = needToCompleteCount + addCount; 

    //         const mainItemIdx = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE].findIndex( item => item == maincategoryObj);

    //     }catch(e){
    //         console.log(categoryObj)
    //         console.log(e.message)
    //     }

 

        // const maincategoryIndex = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE].findIndex( item => item.items === selectedObj.MainCategoryName );
        // const categoryObj = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex].category.filter(item => item.id === selectedObj.CategoryId)[0]

        // try{
        //     let needToCompleteCount = 0

        //     if(categoryObj.subcategory){
        //         for (var i = categoryObj.subcategory.length - 1; i >= 0; i--) {
        //             if(categoryObj.subcategory[i].ischildselection !== 1){
        //                 needToCompleteCount++
        //             }else{
        //                 if(categoryObj.subcategory[i].specs){
        //                     needToCompleteCount = needToCompleteCount + categoryObj.subcategory[i].specs.filter(item => item.ischeckbox === 0).length
        //                 }
        //             }
        //         }
        //     }
 
		// 	//edited
        //     //for isCompeleted function
        //     let addCount = 0;

        //     if(store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex].category){
        //         store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex].category.forEach(item =>{
        //             const tmpRetainObjArr = this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.filter(item => item.id !== 41500);




        //             console.log(tmpRetainObjArr)

        //             if( tmpRetainObjArr.includes(item.id) && item.isinterfacedefault === 1 ){ //2025-05-14 jazz, added is interfacedefault
        //                 addCount++
        //             }
        //         })
        //     }

        //    needToCompleteCount = needToCompleteCount + addCount; 

        //     if(store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex].needtocompletecount !== needToCompleteCount){
        //         const itemObj = {
        //             sheet       : this.Const.SETSUBI_USERINTERFACE,
        //             value       : needToCompleteCount,
        //             index       : maincategoryIndex,
        //             itemToUpdate: 'needtocompletecount',
        //         } 

        //         store.dispatch('UpdateInterfaceItem', itemObj) 
        //     }

        // }catch(e){
        //     console.log(selectedObj)
        //     console.log(e.message)
        // }
    // }
	

    //Mae added 2025-06-27
    static define_ischildselection = ( maincategoryObj, selectedObj ) => {
        let result = false;

        if( maincategoryObj.category ){        
            maincategoryObj.category.forEach( item => {
                if( item.isinterfacedefault === 1 && item.ischeckbox === 0 && item.ischildselection !== 1 && item.subcategory ){
                    item.subcategory.forEach(sub => {
                        if( sub.id === selectedObj.SubcategoryId && 
                            sub.isinterfacedefault === 1 && 
                            sub.ischeckbox === 1 && 
                            sub.ischildselection === 1 ){
                                result = true;
                        }
                    }) 
                }
            })
        }

        return result;
    }

    //Setsubi => mae added 2024-11-22 ( if the data structure same with item 手洗い器付収納 || 宅配ボックス(据置タイプ）)
    static isSelectedistextureChildSelection = ( maincategoryObj, selectedObj ) => {
        const maincategoryIndex = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE].findIndex( item => item.items === selectedObj.MainCategoryName);

        if( this.define_ischildselection( maincategoryObj, selectedObj ) ){
            try{
                let tmpSelectedCount = 0;
    
                if( maincategoryObj.category){        
                    maincategoryObj.category.forEach( item => {
    
                        if( item.ischeckbox === 0 && item.isinterfacedefault === 1 && item.ischildselection !== 1 ){
                            tmpSelectedCount++;
    
                            if( item.subcategory ){
                                item.subcategory.forEach( sub => {
                                    if( sub.ischildselection === 1 && sub.ischeckbox === 1 && sub.isinterfacedefault === 1 && sub.id == selectedObj.SubcategoryId){
                                        tmpSelectedCount--;
    
                                        if( sub.specs ){    
                                            tmpSelectedCount += sub.specs.filter(item => item.ischeckbox === 0 && item.isinterfacedefault == 1 && item.parentid == sub.id).length    
                                        }       
                                    }
                                })
                            }
                        }


                        //for ニッチ only due different item structure.
                        if( item.parentid == 310 ){
                            tmpSelectedCount = 1;
                        }
                        
                    })
                }
    
                //Check if maincategoryIndex is valid before accessing the property
                if (maincategoryIndex !== -1) {
                    const mainCategoryItem = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex];
    
                    if ( mainCategoryItem.needtocompletecount !== tmpSelectedCount) {
                        const itemObj = {
                            sheet: this.Const.SETSUBI_USERINTERFACE,
                            value: tmpSelectedCount,
                            index: maincategoryIndex,
                            itemToUpdate: 'needtocompletecount',
                        };
    
                        store.dispatch('UpdateInterfaceItem', itemObj);
                    }
                } 
    
            }catch(e){
                console.log(e.message);
            }  
        }
    } 

    //Mae added 2025-06-27
    static selectedItem_isunchecktexture = ( selectedObj ) =>{
    
        const maincategoryIndex = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE].findIndex( item => item.items === selectedObj.MainCategoryName);
        const categoryObj = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex].category.filter(item => item.id === selectedObj.CategoryId)[0]

        let isAdjustCount = false;

        if( categoryObj.ischeckbox === 0  && categoryObj.isinterfacedefault === 1 ){
            if(categoryObj.subcategory){
                for (var i = categoryObj.subcategory.length - 1; i >= 0; i--) {
                        let item = categoryObj.subcategory[i];

                        if( item.ischeckbox === 1 &&  item.id == selectedObj.SubcategoryId && item.isunchecktextures === 1 && item.istexture === 1){
                            isAdjustCount = true;
                        }
                }
            }    
        }

        return isAdjustCount;
    }

    //added mae 2025-08-23
    static SetToiletAndSystemBathNeedToCompleteCount = (maincategoryObj, selectedObj) => {
        const maincategoryIndex = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE].findIndex(item => item.items === selectedObj.MainCategoryName);
    
        if ( !maincategoryObj || !maincategoryObj.category ) return 0;

        let isnotcheckboxCount = 0;

        for (let i = 0; i < maincategoryObj.category.length; i++) {
            const cat = maincategoryObj.category[i];
            if (cat.ischeckbox === 0 && cat.isinterfacedefault === 1) {
                isnotcheckboxCount++;
            }
        }

        let result = 0;

        const selectedCat = maincategoryObj.category.find(c => c.id === selectedObj.CategoryId && c.ischeckbox === 1 && c.isinterfacedefault === 1 );
    
        if (selectedCat && Array.isArray(selectedCat.subcategory)) {

            result = selectedCat.subcategory.filter( sub => sub.ischeckbox === 0 && sub.isinterfacedefault === 1 && sub.parentid === selectedObj.CategoryId && sub.ischildselection !== 1).length;

            for (let j = 0; j < selectedCat.subcategory.length; j++) {
                const sub = selectedCat.subcategory[j];

                if (Array.isArray(sub.specs)) {
                    result = result + sub.specs.filter( spec => spec.ischeckbox === 0 && spec.isinterfacedefault === 1 && spec.parentid === sub.id).length;
                }
            }

            const total = isnotcheckboxCount + result;
        
            if (maincategoryIndex !== -1) {
                const mainCategoryItem = store.state.UserInterface[this.Const.SETSUBI_USERINTERFACE][maincategoryIndex];
        
                if (mainCategoryItem.needtocompletecount !== total) {
                    const itemObj = {
                        sheet: this.Const.SETSUBI_USERINTERFACE,
                        value: total,
                        index: maincategoryIndex,
                        itemToUpdate: 'needtocompletecount',
                    };
                    store.dispatch('UpdateInterfaceItem', itemObj);
                }
            }    
        }
    }


    static CheckItemIfCompleted = (maincategoryObj, selectedObj = null) =>{
        if(!maincategoryObj.isdefaultshown) return;
 
        const masterArr = ['GaibuList', 'SetsubiSheet', 'BasicSpecs']

        if(masterArr[maincategoryObj.masterid - 1] !== router.currentRoute.name) return

        let selectedCount = 0
        let tmpArr = []
		
        let is_MONOHOSHI_KANAMONO = false
        let is_MONOHOSHI = false

        //2026-10-21 jazz, 給水工事 allows multiple selections since the 2026-07-07 change -
        //count how many of its items are selected so completion can be judged on "at least one" below,
        //instead of the exact-count match the rest of this function uses.
        let waterSupplySelectedCount = 0

        //2025-05-17 jazz, reduce selecteditems for current route only
        const tmpSelectedItem = store.state.PlanInfo.SelectedItems.filter( item => item.MasterId == (masterArr.findIndex( item => item == router.currentRoute.name ) + 1) )
 
        // let selectedItemsUnique = [...new Map(store.state.PlanInfo.SelectedItems.map(v => [JSON.stringify(v), v])).values()]
        let selectedItemsUnique = [...new Map(tmpSelectedItem.map(v => [JSON.stringify(v), v])).values()]

        // selectedItemsUnique = selectedItemsUnique.filter((tag, index, array) => array.findIndex(t => t.MainCategoryName == tag.MainCategoryName && t.CategoryName == tag.CategoryName && t.SubcategoryName == tag.SubcategoryName && t.SpecsName == tag.SpecsName && t.TextureName == tag.TextureName) == index)

        //2025-05-17 jazz
        selectedItemsUnique = selectedItemsUnique.filter((tag, index, array) => 
            array.findIndex(t => 
                t.MainCategoryName === tag.MainCategoryName &&
                t.CategoryName === tag.CategoryName &&
                t.SubcategoryName === tag.SubcategoryName &&
                t.SpecsName === tag.SpecsName &&
                t.TextureName === tag.TextureName
            ) === index
        );

        for(let j = 0; j < selectedItemsUnique.length; j++){
            if(router.currentRoute.name !== masterArr[selectedItemsUnique[j].MasterId - 1]) continue;

            if(selectedItemsUnique[j].MainCategoryName === maincategoryObj.items){
                //2026-10-21 jazz, count every selected item belonging to 給水工事 before any of the
                //continue/skip branches below so it reflects "is anything selected", not the counting
                //rules those branches apply for other items. Unchecking a 給水工事 texture goes through
                //SaveItemToStore's isparentcheckbox branch, which nulls out the TextureId/TextureName
                //fields on the row instead of removing it (the row is kept so Floor/RoomName/etc. on it
                //survive for other columns) - so a leftover row with MainCategoryName still set but no
                //TextureId must NOT count as a selection, or an unchecked item keeps the mark lit.
                if(maincategoryObj.id === this.Const.WATER_SUPPLY_CONST_ID && selectedItemsUnique[j].TextureId){
                    waterSupplySelectedCount++
                }

                if(selectedItemsUnique[j].CategoryId === this.Const.BATHROOM_TV) continue;

                //default selectedCount for monohoshi =mae 2025-05-15=
                if (selectedItemsUnique[j].SubcategoryParentId === this.Const.MONOHOSHI) {
                    selectedCount = 1;
                }
                
                //2023-11-23
                //2025-08-08 jazz
                // if(!selectedObj && router.currentRoute.name === this.Const.SETSUBI_USERINTERFACE){
                //     if(selectedItemsUnique[j].CategoryId && selectedItemsUnique[j].CategoryId != this.Const.BATHROOM_TV){
                //         if( this.Const.TOILETS_AND_SYSTEM_BATH.includes(selectedItemsUnique[j].MainCategoryId ) && store.state.PlanInfo.isPrevious !== false){
                //             if( tmpArr.length === 0 ){
                //                 tmpArr.push(selectedItemsUnique[j]) 
                //             }
 
				// 			this.SetToiletAndSystemBathNeedToCompleteCount( selectedItemsUnique[j] ) 
                //         }
                //     }
                // }

                //do not count if the item is remarks as "WITHOUT SRS" in conversion table
                if( selectedItemsUnique[j].CategoryId == null && 
                        selectedItemsUnique[j].SubcategoryId == null && 
                        selectedItemsUnique[j].SpecsId == null && 
                        selectedItemsUnique[j].TextureId == null && 
                        selectedItemsUnique[j].ShiyoData  ){
                        continue;
                }
				
                if( selectedItemsUnique[j].TextureName ){
                    selectedCount++ 
                }

                //Count the istexture item
                let isTextureCount = 0;

                if(selectedItemsUnique[j]?.categoryisTexture === 1){
                    selectedCount = maincategoryObj.needtocompletecount;
                }

                //optimzed by Mae 2025-06-27
                if (selectedItemsUnique[j]?.subcategoryisTexture === 1) {
                    isTextureCount++;
                
                    if (maincategoryObj?.masterid === this.Const.SETSUBI_MASTER) {
                        const isunchecktextures = this.selectedItem_isunchecktexture(selectedItemsUnique[j]);
                
                        // For Item [宅配ボックス(据置タイプ)|宅配ボックス(クロークポール)|手洗いカウンター|手洗い器付収納|ホームエレベーター]
                        if (isunchecktextures && isTextureCount === maincategoryObj.category.length) {
                            selectedCount = maincategoryObj.needtocompletecount - 1;
                        }
                
                        // Check for specific items with multiple categories
                        if (isunchecktextures && maincategoryObj.category.length > 1 && maincategoryObj.items === selectedItemsUnique[j].MainCategoryName) {
                            if (Array.isArray(maincategoryObj.category) && maincategoryObj.category.length > 0) {
                                maincategoryObj.category.forEach(item => {

                                    //For Item [浄化槽|エアコン|]
                                    if (item.id === selectedItemsUnique[j].SubcategoryParentId && item.isinterfacedefault === 1 && item.ischildselection === 1) {
                                        if (item.subcategory) {
                                            const CountSubItem = item.subcategory.filter(sub => sub.ischeckbox === 0 && sub.isinterfacedefault === 1 && sub.parentid === selectedItemsUnique[j].SubcategoryParentId).length;
                
                                            if (CountSubItem >= 2) {
                                                selectedCount += CountSubItem - 1;
                                            }
                                        }
                                    }
                
                                    // For Item [セカンド洗面化粧台]
                                    if (item.isinterfacedefault === 1 && item.ischildselection !== 1 && item.ischeckbox === 0) {
                                        if (item.id === selectedItemsUnique[j].SubcategoryParentId && item.subcategory) {
                                            maincategoryObj.needtocompletecount = maincategoryObj.category.filter(item => item.parentid === selectedItemsUnique[j].MainCategoryId).length;
                                        }
                                    }

                                });
                            }
                        }
                    }
                }

                if( selectedItemsUnique[j]?.specsisTexture === 1 ){
                    isTextureCount++
                }

                //item with キッチン壁
                if(this.Const.trigger_textureid_to_uncheckItems.includes( selectedItemsUnique[j].TextureId )){
                    selectedCount = maincategoryObj.needtocompletecount - 1;
                }

                //item without キッチン壁
                if(this.Const.trigger_textureid_to_uncheckItems2.includes( selectedItemsUnique[j].TextureId )){
                    selectedCount = maincategoryObj.needtocompletecount;
                }

                 //2025-05-15
                 if (selectedItemsUnique[j].CategoryId === this.Const.MONOHOSHI_KANAMONO) {
                    is_MONOHOSHI_KANAMONO = true;
                }

                //2025-05-15
                if (selectedItemsUnique[j].CategoryId === this.Const.MONOHOSHI){
                    is_MONOHOSHI = true;
                } 

                //optimized by mae 2025-06-20
                this.isSelectedistextureChildSelection( maincategoryObj, selectedItemsUnique[j] );

                if( this.Const.TOILETS_AND_SYSTEM_BATH.includes(selectedItemsUnique[j].MainCategoryId ) ){
                    this.SetToiletAndSystemBathNeedToCompleteCount( maincategoryObj, selectedItemsUnique[j] ) 
                }    

                selectedCount = selectedCount + isTextureCount
				

                // //if category
                // if(selectedItemsUnique[j].categoryisTexture === 1){
                //     if(selectedObj){
                //         if(maincategoryObj.category){
                //             selectedCount = selectedCount + maincategoryObj.category.filter(item => item.ischeckbox === 0 && item.parentid == selectedObj.parentid).length

                //             if(selectedCount == 0){
                //                 selectedCount = 1
                //             }
                //         }
                //     }else{
                //         selectedCount++
                //     }
                // }

                // //if subcategory
                // if(selectedItemsUnique[j].subcategoryisTexture === 1){
                //     if(selectedObj){
                //         for(let k = 0; k < maincategoryObj.category.length; k++){
                //             if(maincategoryObj.category[k].subcategory){
                //                 selectedCount = selectedCount + maincategoryObj.category[k].subcategory.filter(item => item.isparentcheckbox === 0 && item.parentid == selectedObj.parentid && item.istexture === 1 && item.id === selectedObj.id).length
                //             }
                //         }
                //     }else{  
                //         selectedCount++
                //     }
                // }

                // //if specs
                // if(selectedItemsUnique[j].specsisTexture === 1){
                //     if(selectedObj){
                //         for(let k = 0; k < maincategoryObj.category.length; k++){
                //             if(maincategoryObj.category[k].subcategory){
                //                 for(let l = 0; l < maincategoryObj.category[k].subcategory.length; l++){
                //                     if(maincategoryObj.category[k].subcategory[l].specs){
                //                         selectedCount = selectedCount + maincategoryObj.category[k].subcategory[l].specs.filter(item => item.isparentcheckbox === 0 && item.parentid == selectedObj.parentid && item.istexture === 1).length

                //                         if(selectedCount == 0){
                //                             selectedCount = 1
                //                         }
                //                     }
                //                 }
                //             }
                //         }
                //     }else{
                //         selectedCount++
                //     }
                // }

            }
        }


        if(is_MONOHOSHI_KANAMONO && is_MONOHOSHI){
            selectedCount = maincategoryObj.needtocompletecount
        }else if( (is_MONOHOSHI_KANAMONO && !is_MONOHOSHI) || ( !is_MONOHOSHI_KANAMONO && is_MONOHOSHI ) ){
            selectedCount = 1
        }

        //2026-10-21 jazz, 給水工事 is multi-select (see Category.vue/Textures.vue 2026-07-07 changes) -
        //treat it as completed once at least one of its items is selected, regardless of how many.
        if(maincategoryObj.id === this.Const.WATER_SUPPLY_CONST_ID && waterSupplySelectedCount > 0){
            selectedCount = maincategoryObj.needtocompletecount
        }

        // if(maincategoryObj.items == '宅配ボックス(クロークポール)'){
        //       console.log(maincategoryObj.items + ' --> ' + maincategoryObj.masterid + '\n' + 'selectedCount:' + selectedCount + '\n' + 'needToSelect:' + maincategoryObj.needtocompletecount)    
        // }

        return selectedCount;
    }

    static ReupdateCompletedHint = async (sheetItems, itemName, routeName) =>{
        //map first before loop to make loop faster 2023-12-20 
        const sheetItemsArrMap = sheetItems.map(item => item.items)
 
        for(let i = 0; i < sheetItemsArrMap.length; i++){
            //2026-09-29 jazz, when a specific itemName is given (toggleItem passes the one item that was
            //just clicked), skip every row that isn't it - CheckItemIfCompleted below does an O(M^2)-ish
            //scan over SelectedItems (with a JSON.stringify per item) per call, so running it for every
            //row in the sheet just to discard all but one result made every checkbox click cost
            //O(rows * M^2) instead of O(M^2).
            if(itemName !== '' && sheetItemsArrMap[i] !== itemName) continue;

            let resultValue = false;

            //2026-10-21 jazz, 給水工事 is judged complete by "at least one item selected" (see
            //CheckItemIfCompleted above), not an exact count match - go straight off that count here
            //too, instead of falling through to the "stays true once true" branch below, which would
            //otherwise keep the mark lit after its last selected item is removed.
            if(sheetItems[i].id === this.Const.WATER_SUPPLY_CONST_ID){
                resultValue = this.CheckItemIfCompleted(sheetItems[i]) > 0;
            }else if(this.CheckItemIfCompleted(sheetItems[i]) === sheetItems[i].needtocompletecount){
                resultValue = true;
            }else{
                if(sheetItems[i].iscompleted == true){
                    resultValue = true;
                }else{
                    resultValue = false;
                }
            }
            if(itemName !== ''){
                if(sheetItemsArrMap[i] === itemName){   
                    const itemObj = {
                        sheet       : routeName,
                        //value       : (this.CheckItemIfCompleted(sheetItems[i]) === sheetItems[i].needtocompletecount) ? true:false,
                        value : resultValue,
                        index       : i,
                        itemToUpdate: 'iscompleted',
                    }   

                    await store.dispatch('UpdateInterfaceItem', itemObj)
                }
            }else{
                const itemObj = {
                    sheet       : routeName,
                    //value       : (this.CheckItemIfCompleted(sheetItems[i]) === sheetItems[i].needtocompletecount) ? true:false,
                    value : resultValue,
                    index       : i,
                    itemToUpdate: 'iscompleted',
                }  

                await store.dispatch('UpdateInterfaceItem', itemObj)    
            }
        }
    }

    static SetPreselectedWhenActive = async (maincategoryObj, columnToUpdate) =>{
        if(maincategoryObj.isdefaultshown){
            let tmpArr = []

            let tmpObj = {
                maincategory: maincategoryObj,
                category    : null, 
                subcategory : null,
                specs       : null,
                texture     : null,
            }

            maincategoryObj.category.forEach(categoryitem =>{
                if(categoryitem.subcategory){
                    categoryitem.subcategory.forEach(subcategoryitem =>{
                        if(subcategoryitem.textureList){
                            subcategoryitem.textureList.forEach(textureitem =>{
                                if (textureitem.selectedwhenactive) {
                                    if( this.isHouseTypeExist( textureitem.selectedwhenactive )){
                                        tmpObj.category     = categoryitem
                                        tmpObj.subcategory  = subcategoryitem
                                        tmpObj.texture      = textureitem
                                        tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                    }
                                }
                            })
                        }
                    })
                }
            })
            

            if(tmpArr.length > 0 && !store.state.UserInterface.isViewDisabled){
                for(let i = 0; i < tmpArr.length; i++){

                        // let previousCountValue = store.state.UserInterface.CompletionData[index].completedcount ? store.state.UserInterface.CompletionData[index].completedcount:0;

                        // let tmpObj = {
                        //    maincategoryname: maincategoryObj.items,
                        //    maincategoryid: maincategoryObj.id,
                        //    completedcount: previousCountValue + 1,
                        // }

                        //store.dispatch('CompletionData', tmpObj)


                    let tmpSelectedItem = {
                        MainCategoryName: tmpArr[i].MainCategoryName,
                        CategoryName: tmpArr[i].CategoryName,
                        CategoryId: tmpArr[i].CategoryId,
                        SubcategoryName: tmpArr[i].SubcategoryName,
                        SpecsName: tmpArr[i].SpecsName,
                        TextureName: tmpArr[i].TextureName
                    }

                    bus.$emit(`UpdatePreselected${columnToUpdate}`, tmpSelectedItem)
                    store.dispatch('AddToSelectedItems', tmpArr[i] )
                }
            }
        }
    }

    //2026-09-28 jazz, mergeWithExisting: when true, unions the computed defaults with whatever is already in
    //store.state.PlanInfo.SelectedItems instead of replacing it wholesale. Needed when this runs a second time
    //for sheets imported in the background (e.g. GaibuList/SetsubiSheet after BasicSpecs is already displayed),
    //so it doesn't wipe out BasicSpecs' own preselections/user edits already committed to the store.
    static SetPreselected = async ( param, mergeWithExisting = false ) =>{
        let tmpArr = []

        let tmpObj = {
            maincategory: null,
            category    : null, 
            subcategory : null,
            specs       : null,
            texture     : null,
        }

        param.forEach(maincategory =>{
            if(maincategory.isdefaultshown){
                tmpObj.maincategory = null
                tmpObj.category = null
                tmpObj.subcategory = null
                tmpObj.specs = null
                tmpObj.texture = null

                if( maincategory.category ){
                    if(maincategory.category.length > 0 ){
                        maincategory.category.forEach(category =>{
                            if( category.isinterfacedefault == 0 ) return; //2025-05-06 jazz

                            if ( category.isselected ) {
                                if ( this.isHouseTypeExist( category.isselected) ){
                                    tmpObj.maincategory = maincategory
                                    tmpObj.category     = category
                                    tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                }
                            }

                            if (category.subcategory){
                                category.subcategory.forEach(subcategory =>{
                                    if (subcategory.isselected) {
                                        if ( this.isHouseTypeExist( subcategory.isselected ) ){
                                            tmpObj.maincategory = maincategory
                                            tmpObj.category     = category
                                            tmpObj.subcategory  = subcategory

                                            tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                        }
                                    }

                                    if (subcategory.textureList) {
                                        subcategory.textureList.forEach(subcategorytexture =>{
                                            if(subcategorytexture.isselected) {
                                                if ( this.isHouseTypeExist( subcategorytexture.isselected ) ){
                                                    tmpObj.maincategory = maincategory
                                                    tmpObj.category     = category
                                                    tmpObj.subcategory  = subcategory
                                                    tmpObj.texture      = subcategorytexture

                                                    tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                                }
                                            }
                                        })
                                    }

                                    if(subcategory.specs){
                                        subcategory.specs.forEach(spec =>{
                                            if (spec.isselected) {
                                                if( this.isHouseTypeExist( spec.isselected )){
                                                    tmpObj.maincategory = maincategory
                                                    tmpObj.category     = category
                                                    tmpObj.subcategory  = subcategory
                                                    tmpObj.specs        = spec

                                                    tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                                }
                                            }

                                            if (spec.textureList){
                                                spec.textureList.forEach(spectexture =>{
                                                    if (spectexture.isselected) {
                                                        if( this.isHouseTypeExist( spectexture.isselected )){
                                                            tmpObj.maincategory = maincategory
                                                            tmpObj.category     = category
                                                            tmpObj.subcategory  = subcategory
                                                            tmpObj.specs        = spec
                                                            tmpObj.texture      = spectexture

                                                            tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                                        }
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }

                            if (category.textureList) {
                                if(category.isinterfacedefault === 1){
                                    category.textureList.forEach(categorytexture =>{
                                        if (categorytexture.isselected){
                                            if ( this.isHouseTypeExist( categorytexture.isselected )){
                                                tmpObj.maincategory = maincategory
                                                tmpObj.category     = category
                                                tmpObj.texture      = categorytexture

                                                tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                            }   
                                        }
                                    })
                                }


                            }
                        })
                    }
                }

                if(maincategory.textureList){
                    if (maincategory.textureList.length > 0) {
                        maincategory.textureList.forEach(texture =>{
                            if ( texture.isselected ) {
                                if ( this.isHouseTypeExist( texture.isselected ) ) {
                                    tmpObj.maincategory = maincategory
                                    tmpObj.texture      = texture
                                    tmpArr.push( this.SelectedDataObj( tmpObj.maincategory, tmpObj.category, tmpObj.subcategory, tmpObj.specs, tmpObj.texture ) )
                                }
                            }
                        })
                    }
                }
            }
        })


        if(param.length > 1){
            //2026-09-28 jazz, union with current SelectedItems when merging a background-loaded sheet in
            const finalArr = mergeWithExisting ? [...store.state.PlanInfo.SelectedItems, ...tmpArr] : tmpArr
            store.dispatch('SelectedItems', this.GetUniqueValueArray(finalArr, 'RowIndex'))
        }else{
            if(tmpArr.length > 0 && !store.state.UserInterface.isViewDisabled){
                const UniqArray = this.GetUniqueValueArray(tmpArr, 'RowIndex');

                for(let i = 0; i < UniqArray.length; i++){
                    let tmpSelectedItem = {
                        MainCategoryName: UniqArray[i].MainCategoryName,
                        CategoryName: UniqArray[i].CategoryName,
                        CategoryId: UniqArray[i].CategoryId,
                        SubcategoryName: UniqArray[i].SubcategoryName,
                        SpecsName: UniqArray[i].SpecsName,
                        TextureName: UniqArray[i].TextureName,
                    }

                    const Event = ['Category', 'Subcategory', 'Specs', 'Texture'];

                    for(let j = 0; j < Event.length; j++){
                        bus.$emit(`UpdatePreselected${Event[j]}`, tmpSelectedItem)
                    }
                }

                //2026-10-07 jazz, one store write instead of one per row. This loop used to dispatch
                //AddToSelectedItems per row, and because vuex-persistedstate re-serialises the entire
                //store to localStorage on every mutation, checking an item with many preselected defaults
                //cost one full-store write per row. Note the sibling branch above (param.length > 1, the
                //bulk sheet-load path) already did a single dispatch - only this single-item path, which
                //is the one toggleItem uses, was writing per row.
                //Moving the dispatch after the emit loop is safe: no UpdatePreselected* listener reads
                //PlanInfo.SelectedItems (Category/SubCategory/Textures each only read the emitted
                //payload, and nothing listens to UpdatePreselectedSpecs), so no listener can observe the
                //intermediate store states this used to produce.
                store.dispatch('AddManyToSelectedItems', UniqArray)
            } 
        }
    }

    static importMasters = async (functionName) =>{
        clearPersistedState();

        try{

            switch(functionName){
                case 'MenuItems':
                    await this.SetMenuItems();
                    break;
                case 'HouseTypes':
                    await this.importHouseTypes();
                    break;
                // case 'RoomNames':
                //     await setsubiSheet.ImportRoomNamesToStore();
                //     break;
                case 'SheetItems':
                    await this.getSheetItems();
                    break;
                default:
                    await this.SetMenuItems();
                    await this.importHouseTypes();
                    //await setsubiSheet.ImportRoomNamesToStore();
                    await this.getSheetItems();
            }
        }catch(e){
            console.log(e)
        }
    }

    static RetainSelectedItem = (instance, columnname) =>{
        if(instance[`filtered${columnname}`]){
            let selectedCount = 0
            let tmpObj = {
                itemName: null,
                selectedCount: 0,
                masterId: null
            };

            const filteredColumnMap = instance[`filtered${columnname}`].map(item => item.items)
            const selectedItemsMap = store.state.PlanInfo.SelectedItems.map(item => item.MainCategoryName)

            for (let i = 0; i < filteredColumnMap.length; i++ ) { 
            //for (let i = 0; i < instance[`filtered${columnname}`].length; i++ ) { 
                const currentSelectedItem = ((instance[`filtered${columnname}`][i].items) ? instance[`filtered${columnname}`][i].items: instance[`filtered${columnname}`][i].texturename)
                const currentItemId = instance[`filtered${columnname}`][i].id 
                
                //To retain toilet category
                if(this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(currentItemId)) continue;  

 
                for (let j = 0; j < selectedItemsMap.length; j++) {
                    if (instance[`filtered${columnname}`][i].masterid != store.state.PlanInfo.SelectedItems[j].MasterId) continue;
                    if (instance.filteredMaincategory.items != store.state.PlanInfo.SelectedItems[j].MainCategoryName) continue;
                    if( currentItemId != store.state.PlanInfo.SelectedItems[j][`${columnname}Id`]) continue;

                    let column = 'texturename'

                    if(columnname !== 'Texture'){
                        column = 'items'
                    }

                    const selectedItem =  (instance[`filtered${columnname}`] ).filter(item => item.id === currentItemId).map(item => item[`${column}`])[0]


                    instance[`selected${columnname}`] = selectedItem
                }   
            }
        }
    }

    static SetUserEditedItem = (interfaceItemsArr) =>{
        //replace items if editable by user
        if ( store.state.UserInterface.isViewDisabled || store.state.PlanInfo.CopyPlan != false ) {
            for(let maincategoryitem of interfaceItemsArr){
                for(let selecteditem of store.state.PlanInfo.SelectedItems){                            
                    if ( selecteditem.MainCategoryName == maincategoryitem.items ) {
                        if ( maincategoryitem.category ) {
                            if ( maincategoryitem.category.length > 0 ) {
                                for(let categoryitem of maincategoryitem.category){
                                    if ( categoryitem.items ){                                        
                                        if ( categoryitem.ischeckbox == 1 && /\s+.+\s/.test(selecteditem.CategoryName) && categoryitem.items.includes( ' __ ' ) ) {
                                            categoryitem.items = selecteditem.CategoryName
                                        } 
                                    }

                                    if ( categoryitem.textureList ) {
                                        for(let categorytexture of categoryitem.textureList){
                                            if ( categorytexture.id == selecteditem.TextureId ) {
                                                categorytexture.texturename = selecteditem.TextureName 
                                            }
                                        }
                                    }

                                    if ( categoryitem.subcategory ) {
                                        if ( categoryitem.subcategory.length > 0 ) {
                                            for(let subcategoryitem of categoryitem.subcategory){

                                                if ( subcategoryitem.items ){
                                                    if ( subcategoryitem.ischeckbox == 1 && /\s+.+\s/.test(selecteditem.SubcategoryName) && subcategoryitem.items.includes( ' __ ' ) ) {
                                                        subcategoryitem.items = selecteditem.SubcategoryName
                                                    }
                                                } 

                                                if ( subcategoryitem.textureList ) {
                                                    for(let subcategorytexture of subcategoryitem.textureList){
                                                        if ( subcategorytexture.id == selecteditem.TextureId ) {
                                                            subcategorytexture.texturename = selecteditem.TextureName 
                                                        }
                                                    }
                                                } 
                                                
                                                if ( subcategoryitem.specs ) {
                                                    if ( subcategoryitem.specs > 0 ) {
                                                        for(let specsitem of subcategoryitem.specs){
                                                            if ( specsitem.items ){
                                                                if ( specsitem.ischeckbox == 1 && /\s+.+\s/.test(selecteditem.SpecsName) && specsitem.items.includes( ' __ ' )) {
                                                                    specsitem.items = selecteditem.SpecsName
                                                                } 
                                                            }


                                                            if ( specsitem.textureList ) {
                                                                for(let specstexture of specsitem.textureList){
                                                                    if ( specstexture.id == selecteditem.TextureId ) {
                                                                        specstexture.texturename = selecteditem.TextureName 
                                                                    }
                                                                }
                                                            } 
                                                        }                                                                
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if ( maincategoryitem.textureList ) {
                            if ( maincategoryitem.textureList.length > 0 ) {
                                for(let maincategorytexture of maincategoryitem.textureList){
                                    if ( maincategorytexture.id == selecteditem.TextureId ) {
                                        maincategorytexture.texturename = selecteditem.TextureName 
                                    }
                                }                                                           
                            }
                        } 
                    }
                } 
            } //end loop
        }
    }

    static SRSVersion = async () =>{
        try{
            const data = await this.axiosObj.get(`${process.env.MIX_API_BASEURL}/api/version`);
            return data.data;
        }catch{
            console.log('cannot get version info')
        }
    }

    //2023-03-31 jazz
    // static deleteExistingShiyoForCompletion = async () =>{
    //     try{
    //         const response = await axios.delete(`${process.env.MIX_API_BASEURL}/api/delete-for-completion-list`)
    //         return response.data
    //     }catch{
    //         console.log('error in deletion existing shio')
    //     }
    // }

    static AddItemsToInterface = async (routename) =>{
        let selectedItems  = (await store.state.PlanInfo.SelectedItems) //remove the condition when Gaibulist is refactored
        let clonedArray = JSON.parse(JSON.stringify(await store.state.UserInterface[routename])) 
        let tmpObj = [];
        let itemToAdd = [];


        
        for(let i = 0; i < clonedArray.length; i++ ){
            for(let j = 0; j < selectedItems.length; j++){
                let originalItemName = selectedItems[j].MainCategoryName.replace(/\([2-9]\)/g, '');
				
                // modify by mae 2025-04-25
                let isinMaxValue = /\([1][0-9]|20|[2][1-9]|30\)$/.test(originalItemName) ? true: false;

                if( originalItemName !== clonedArray[i].items ){
                     if(isinMaxValue){
                        originalItemName = originalItemName.split('(')[0];
                     }
                }


                if ( (originalItemName === clonedArray[i].items ) && 
                         clonedArray[i].ismultiple == 1 &&  
                        /\([2-9]|[1][0-9]|20|[2][1-9]|30\)$/.test(selectedItems[j].MainCategoryName) 
                        ){  

                    tmpObj = JSON.parse(JSON.stringify(clonedArray[i]))
                    tmpObj['items'] = selectedItems[j].MainCategoryName 
                    tmpObj['ismultiple'] = 1 //2024-05-22 modified jazz
                    tmpObj['isdefaultshown'] = true;  

                    if(/\([1][0-9]|20|[2][1-9]|30\)$/.test(tmpObj['items'])){
                        const parts = tmpObj.items.split('(');
                        if (parts.length > 1) {
                            const numberPart = parts[1].split(')')[0]; 
                            tmpObj['seq'] = numberPart; 
                        } else {
                            tmpObj['seq'] = null; 
                        }
                    }else{
                        tmpObj['seq'] = /[(]\d[)]/.exec(tmpObj.items)[0].replace(/[)]|[(]/g,'') 
                    }

                    //2023-12-12
                    if(tmpObj.category){
                        tmpObj.category.forEach(categoryitem =>{
                            for (var j = store.state.PlanInfo.SelectedItems.length - 1; j >= 0; j--) {
                                if(categoryitem.isinterfacedefault === 0){
                                    if(store.state.PlanInfo.SelectedItems[j].MainCategoryName === tmpObj.items){
                                        if(store.state.PlanInfo.SelectedItems[j].CategoryName === categoryitem.items){
                                            tmpObj['needtocompletecount']++
                                            categoryitem.isinterfacedefault = 1
                                        }
                                    }
                                }
                            }
                        })
                    }
                    itemToAdd.push( tmpObj ); 
                }
            }
        }

        const arrUniq = [...new Map(itemToAdd.map(v => [v.items, v])).values()]

        for(let item of arrUniq){
            await store.dispatch(`AddUser${routename}`, item) 
        }

        this.SetUserEditedItem(store.state.UserInterface[routename])
    }

    // static HighLightItem = (instance) =>{
    //     bus.$on('highlightItem',  () =>{
    //         instance.scrollToItem = store.state.PlanInfo.EditKey
    //     })
    // }

    //2025-08-22 jazz
    // static LinkColumn = (instance, columnname) =>{
    //     bus.$on(`link${columnname}`, (data) =>{
    //         if (data.columnname == 'Specs') {
    //             if (data.instance) {
    //                 if (data.instance.filteredMaincategory.items == instance.filteredMaincategory.items) {
    //                     if (data.instance.filteredCategory.id == instance.filteredCategory.id) {
    //                         instance.selectedSubcategory = null
    //                     }
    //                 }
    //             }
    //         }
    //         if (instance.filteredMaincategory.items == data.maincategoryname) {
    //             switch (columnname) {
    //                 case 'Category':
    //                     instance.selectedCategory = data.items


    //             // let param = {
    //             //     instance  : instance,
    //             //     columnname: 'Category',
    //             //     itemArr   : data,
    //             //     isclicked : true,
    //             //     // rowitems  : this.rowItems
    //             // }
                
     
    //                 break;
    //                 case 'Subcategory':
    //                     if (data.parentid == instance.filteredCategory.id) {
    //                         instance.selectedSubcategory = data.items
    //                     }
    //                 break;
    //                 case 'Specs':
    //                     if (data.ischeckbox == 0) {
    //                       if (data.parentid == instance.filteredCategory.id) {
    //                           instance.selectedSubcategory = data.items
    //                       }
    //                     } else {
    //                         if (data.parentid == instance.filteredSubcategory.id) {
    //                             instance.selectedSpecs = data.items
    //                         }
    //                     }
    //                 break;
    //             }
    //             if (data.isnull) {
    //                 instance[`selected${columnname}`] = null
    //                 data.isnull = null
    //             }
    //             data.columnname = columnname

    //             bus.$emit('uncheckrelatedtexture', data)

    //             let tmpObjKey = null
    //             let tmpObjArr = []
    //             switch (data.groupid) {
    //                 case 1: tmpObjKey = 'MainCategoryId'; break;
    //                 case 2: tmpObjKey = 'CategoryId'; break;
    //                 case 3: tmpObjKey = 'SubcategoryId'; break;
    //                 case 4: tmpObjKey = 'SpecsId'; break;
    //             }
    //             instance[`filtered${columnname}`].forEach(item =>{
    //                 if (item.isunchecktextures == 1) {
    //                     tmpObjArr.push(item.id)   
    //                 }
    //             })
    //             tmpObjArr.forEach(item =>{
    //                 if (store.state.PlanInfo.SelectedItems.map(e => e[tmpObjKey] ).indexOf( item ) > -1) {
    //                     instance.$PlanData.removeItemInSelected(store.state.PlanInfo.SelectedItems.map(e => e[tmpObjKey] ).indexOf( item ) )
    //                 }
    //             })
    //           //if (data.isnull) {
    //           //   instance[`selected${columnname}`] = null
    //           //}
    //         }
    //     })
    // }

    static generateSortFn = (props) => {
        return function (a, b) {
            for (var i = 0; i < props.length; i++) {
                var prop = props[i];
                var name = prop.name;
                var reverse = prop.reverse;
                if (a[name] < b[name])
                    return reverse ? 1 : -1;
                if (a[name] > b[name])
                    return reverse ? -1 : 1;
            }
            return 0;
        };
    };

    //2025-08-22 jazz
    // static restructureJSONShioData = ( selectedItems ) =>{
    //     function isEditableSuryo( master ){
    //         const NOT_DISPLAY_SURYO_1    = ['9999999', '0000002'];
    //         const MONOHOSHI_KANAMONO_CD  = '0110';
    //         const INDOOR_CLOTHES_LINE_CD = '0340';
    //         const SETSUBI_MASTER         = 2;

    //         result = false;

    //         if( master.komokuCd1 == MONOHOSHI_KANAMONO_CD && 
    //             master.komokuCd2 == INDOOR_CLOTHES_LINE_CD && 
    //             master.siyoKbn == SETSUBI_MASTER &&
    //             !NOT_DISPLAY_SURYO_1.includes(master.shohinCd)
    //         ){
    //             result = true;
    //         }
 
    //         return result;
    //     }

    //     function getCategoryArr( maincategoryName, itemCD1, masterArr, seq = null, constval, planNo, itemNumber ){
    //         if( !maincategoryName ) return [];        

    //         let tmpArr = [];

    //         for( const master of masterArr ){
    //             const masterItemCD1   = master.kihonsiyoCd ? master.kihonsiyoCd:master.komokuCd1 || master.komokuCd2;
    //             const masterItemCD2   = master.komokuCd2;
    //             const subcategoryName = ([master.shohinName, master.siyoDetailName, master.siyoDetailName1]).filter(Boolean)[0] ;
 
    //             const seqNo = master.seqNo ? master.seqNo:null;

    //             if( !subcategoryName || seqNo != seq || masterItemCD1 != itemCD1 ) continue;

    //             const tmpObj = {
    //                 planno: planNo,
    //                 maincategoryname: maincategoryName,
    //                 itemnumber      : itemNumber,
    //                 name: /[^基本|内部]/.test(master.mastername) ? master.komokuName2:'ー',
    //                 specsname: (master.suryo > 1 || isEditableSuryo(master) ) ? String(master.suryo):' ',
    //                 // subcategoryname: subcategoryName +   '<span class="red--text">'+ masterItemCD2 +'</span>', //2025-03-06 temp
    //                 subcategoryname: subcategoryName,
    //                 texturename: master.colorShanai,
    //                 cd2 : masterItemCD2 
    //             }

    //             tmpArr.push( tmpObj )
    //         }
            
    //         return tmpArr;
    //     }

    //     if( !selectedItems ) return;

    //     let counter = 0;

    //     let masterArr = [];
    //     const sheetNameArr = ['基本', '外部', '設備', '内部'];

    //     for( const key in selectedItems ){
    //         if( /[^kihon|gaibu|setsubi|naibu]/.test(key) ) continue;

    //         counter++
    //         const sheetArr = selectedItems[key].map(item => ({ ...item, masterid: counter, mastername: sheetNameArr[counter - 1] }))

    //         masterArr.push( sheetArr )  
    //     }

    //     let tmpArr = [];

    //     for( const master of masterArr ){
    //         const constructionCode = selectedItems.construction_code 
    //         const planNo           = selectedItems.plan_no
    //         const shioNo           = selectedItems.shio_no
    //         const houseType        = selectedItems.house_type

    //         //unique
    //         const mainItemArr = [...new Map(master.map(item => [(item.komokuCd1 ? item.komokuCd1+'_'+item.seqNo+'_'+item.masterid:item.kihonsiyoCd || item.floorNum+'_'+item.roomCd+'_'+item.komokuCd2+'_'+item.seqNo), item ])).values()];
    //         mainItemArr.sort( this.generateSortFn([{name: 'komokuCd1', reverse: false}, {name: 'seqNo', reverse: false}]) );

    //         let counter = 0;

    //         for( const mainitem of mainItemArr ){    
    //             const name    = mainitem.kihonsiyoName ? mainitem.kihonsiyoName:mainitem.komokuName1 || mainitem.komokuName2;
    //             const itemCD1 = mainitem.kihonsiyoCd ? mainitem.kihonsiyoCd:mainitem.komokuCd1 || mainitem.komokuCd2;
    //             const itemCD2 = mainitem.komokuCd2 ? mainitem.komokuCd2:'ー';

    //             if( !name ) continue;

    //             const categoryArr = getCategoryArr(name, itemCD1, master, mainitem.seqNo, this.Const, planNo, mainitem.zumenShijiNoDisp); 

    //             let mainItemName = '';

    //             if( mainitem.zumenShijiNoDisp ){
    //                 mainItemName = `<br><span style="font-size: 20px;">${mainitem.zumenShijiNoDisp}</span>`;
    //             }
 
    //             const tmpObj = {
    //                 constructioncode : constructionCode,
    //                 planno           : planNo,
    //                 shiono           : shioNo,
    //                 housetype        : houseType,
    //                 masterid         : mainitem.masterid,
    //                 seqno            : mainitem.seqNo,
    //                 mastername       : mainitem.mastername,
    //                 name             : mainitem.seqNo > 1 ? `${name}(${mainitem.seqNo})${mainItemName}`:`${name}${mainItemName}--${mainitem.masterid}`,
    //                 cd1              : itemCD1,
    //                 itemnumber       : mainitem.zumenShijiNoDisp ? mainitem.zumenShijiNoDisp:null,
    //                 floor            : mainitem.floorNum,
    //                 room             : mainitem.roomName,
    //                 category         : categoryArr.sort( this.generateSortFn([{name: 'cd2', reverse: false}]) )
    //             };

    //             //2025-05-22 jazz, check name and modify mastername
    //             if( tmpObj.name ){
    //                 if( /^\w{4,}Col\d?f?/.test( tmpObj.cd1 ) ){
    //                     tmpObj.mastername = `内部<br>${tmpObj.mastername}`     
    //                 }
    //             }
 
    //             tmpArr.push( tmpObj ) 
    //         }
    //     }

    //     return tmpArr;
    // }

    static restructureJSON = (selectedItems) =>{
        function getHinbanInDuplicates(duplicateArr, maincategoryName){
            const itemArr = duplicateArr.filter(item =>{ return item.MainCategoryName == maincategoryName && item.Hinban })
            let result = null

            if (itemArr.length > 0){
                result = itemArr[0].Hinban
            }

            return result
        }

        function getFloorInDuplicates(duplicateArr, maincategoryName){
            const itemArr = duplicateArr.filter(item =>{ return item.MainCategoryName == maincategoryName && item.Floor && item.Floor != '--' })
            let result = null

            if (itemArr.length > 0){
                result = itemArr[0].Floor
            }

            return result
        }

        function getRoomNameInDuplicates(duplicateArr, maincategoryName){
            const itemArr = duplicateArr.filter(item =>{ return item.MainCategoryName == maincategoryName && item.RoomName && item.RoomName != '--' })
            let result = null

            if (itemArr.length > 0){
                result = itemArr[0].RoomName
            }

            return result
        }

        function getItemNumberInDuplicates(duplicateArr, maincategoryName){
            const itemArr = duplicateArr.filter(item =>{ return item.MainCategoryName == maincategoryName && item.ItemNumber && item.ItemNumber != '--' })
            let result = null

            if (itemArr.length > 0){
                result = itemArr[0].ItemNumber
            }

            return result
        }

        function generateSortFn( props ) {
            return function (a, b) {
                for (var i = 0; i < props.length; i++) {
                    var prop = props[i];
                    var name = prop.name;
                    var reverse = prop.reverse;
                    if (a[name] < b[name])
                        return reverse ? 1 : -1;
                    if (a[name] > b[name])
                        return reverse ? -1 : 1;
                }
                return 0;
            };
        };

        //2025-04-25 jazz
        function addObsoletedKanji( obj, columnname ){
            let result = obj[`${columnname}Name`]; 
            //2025-05-20, jazz modify condition
            if( obj[`${columnname}IsObsoleted`] && obj[`${columnname}Name`] ){
                result = `${obj[`${columnname}Name`]} [廃番]` 
            }

            return result;
        }

        let result = []
        let duplicateCategory = selectedItems.reduce((a, e) => { a.set(e.MainCategoryName, (a.get(e.MainCategoryName) ?? 0) + 1);  return a; }, new Map());
        duplicateCategory = selectedItems.filter(e => duplicateCategory.get(e.MainCategoryName) > 1)

        let UniqueItemArr = [...new Map(selectedItems.map(item => [item.MainCategoryName, item])).values()] 

        // UniqueItemArr.sort(generateSortFn([{name: 'sortno', reverse: false}, {name: 'subcategorysortno', reverse: false}, {name: 'specssortno', reverse: false}]));

        UniqueItemArr.forEach(item =>{
            let tmpObj = {
                rowcount: 0
            }

            let tmpCategory = []

            if(item.MasterId == 2){
                if(!tmpObj.floor){
                    tmpObj.floor = item.Floor

                    if(tmpObj.floor == '--' || !tmpObj.floor){
                        tmpObj.floor = getFloorInDuplicates(duplicateCategory, item.MainCategoryName)
                    }
                }

                if(!tmpObj.room){
                    tmpObj.room = item.RoomName

                    if(tmpObj.room == '--' || !tmpObj.room){
                        tmpObj.room = getRoomNameInDuplicates(duplicateCategory, item.MainCategoryName)
                    }
                }

                if(!tmpObj.hinban){
                    tmpObj.hinban = item.Hinban

                    if(tmpObj.hinban == '--' || !tmpObj.hinban){
                        tmpObj.hinban = getHinbanInDuplicates(duplicateCategory, item.MainCategoryName)
                    }
                }

                if(!tmpObj.itemnumber){
                    tmpObj.itemnumber = item.ItemNumber

                    if(tmpObj.itemnumber == '--' ){
                        tmpObj.itemnumber = getItemNumberInDuplicates(duplicateCategory, item.MainCategoryName)
                    }
                }
            }   

            //Added Line 2023-09-01 Jazz
            if(Array.isArray(item.SortNo)){
                item.SortNo.forEach(sortObj =>{
                    if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                        tmpObj.sortno = sortObj.sortno;  
                    }
                })
            }else{
                tmpObj.sortno = item.SortNo;    
            }

            const masterIdNameArr = ['外部', '設備', '基本'];

            tmpObj.name       = item.MainCategoryName 
            tmpObj.comment    = item.MainCategoryComment
            tmpObj.kind       = item.Kind 
            tmpObj.id         = item.MainCategoryId
            tmpObj.masterid   = item.MasterId
            tmpObj.mastername = masterIdNameArr[item.MasterId - 1]; //2025-02-26 jazz
            tmpObj.ismodified = item.Modified
            tmpObj.highlight  = null
            tmpObj.bgcolor    = (item.Modified ? '#ffffb3':'#FAFAFA')
            //tmpCategory.name  = item.CategoryName
            tmpCategory.name  = addObsoletedKanji( item, 'Category' ) //2025-04-25 jazz, add discontinued kanji
            tmpCategory.maincategoryname = item.MainCategoryName
            tmpCategory.categorycomment  = item.CategoryComment
            tmpCategory.parentid  = item.CategoryParentId
            tmpCategory.id    = item.CategoryId

            if(Array.isArray(item.CategorySort)){
                item.CategorySort.forEach(sortObj =>{
                    if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                        tmpCategory.sortno = sortObj.sortno;  
                    }
                })
            }else{
                tmpCategory.sortno = item.CategorySort;    
            }

            tmpCategory.rowindex   = item.RowIndex
            // tmpCategory.subcategoryname = item.SubcategoryName
            tmpCategory.subcategoryname    = addObsoletedKanji( item, 'Subcategory' ) //2025-04-25 jazz, add discontinued kanji
            tmpCategory.subcategorycomment = item.SubcategoryComment
            tmpCategory.subcategoryid      = item.SubcategoryId
            // tmpCategory.specsname       = item.SpecsName
            tmpCategory.specsname          = addObsoletedKanji( item, 'Specs' ) //2025-04-25 jazz, add discontinued kanji
            tmpCategory.specscomment       = item.SpecsComment
            tmpCategory.specsid            = item.SpecsId
            //tmpCategory.texturename      = item.TextureName
            tmpCategory.texturename          = addObsoletedKanji( item, 'Texture' ) //2025-04-25 jazz, add discontinued kanji
            tmpCategory.texturecomment  = item.TextureComment
            tmpCategory.textureid       = item.TextureId
            tmpCategory.maincategoryistexture   = item.istexture // maincategory
            tmpCategory.categoryistexture       = item.categoryisTexture // category
            tmpCategory.subcategoryistexture    = item.subcategoryisTexture // subcategory
            tmpCategory.specsistexture          = item.specsisTexture // specs 
            tmpObj.category  = [tmpCategory]

            result.push(tmpObj)
        })

        let tmpArr = [];

        result.forEach(item =>{
            let tmpCategory = []

            for (let j = 0; j < duplicateCategory.length; j++) {
                if (item.name !== duplicateCategory[j].MainCategoryName) continue;
                if(tmpArr.includes(duplicateCategory[j].RowIndex)) continue;

                if(!duplicateCategory[j].SubcategoryName && !duplicateCategory[j].SpecsName && !duplicateCategory[j].TextureName){
                    if(!duplicateCategory[j].CategoryName){
                        continue;
                    }else{
                        if(!duplicateCategory[j].categoryisTexture){
                            continue;
                        }

                    }
                }

                let tmpObj = {}

                tmpObj.parentid = duplicateCategory[j].CategoryParentId
                // tmpObj.name = duplicateCategory[j].CategoryName
                tmpObj.name   = addObsoletedKanji( duplicateCategory[j], 'Category' ) //2025-04-25 jazz, add discontinued kanji
                tmpObj.categorycomment = duplicateCategory[j].CategoryComment
                tmpObj.maincategoryname = duplicateCategory[j].MainCategoryName
                tmpObj.id   = duplicateCategory[j].CategoryId

                if(Array.isArray(duplicateCategory[j].CategorySort)){
                    duplicateCategory[j].CategorySort.forEach(sortObj =>{
                        if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                            tmpObj.sortno = sortObj.sortno;  
                        }
                    })
                }else{
                    tmpObj.sortno = duplicateCategory[j].CategorySort;    
                }

                tmpObj.subcategoryname = duplicateCategory[j].SubcategoryName

                //Added Line 2023-09-01 Jazz
                if(Array.isArray(duplicateCategory[j].SubcategorySort)){
                    duplicateCategory[j].SubcategorySort.forEach(sortObj =>{
                        if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                            tmpObj.subcategorysortno = sortObj.sortno;  
                        }
                    })
                }else{
                    tmpObj.subcategorysortno = duplicateCategory[j].SubcategorySort;    
                }

                //Added Line 2023-09-01 Jazz
                if(Array.isArray(duplicateCategory[j].SpecsSort)){
                    duplicateCategory[j].SpecsSort.forEach(sortObj =>{
                        if(sortObj.houseapplicable.includes(this.HouseTypeNumber())){
                            tmpObj.specssortno = sortObj.sortno;  
                        }
                    })
                }else{
                    tmpObj.specssortno = duplicateCategory[j].SpecsSort;    
                }

                tmpObj.subcategorycomment = duplicateCategory[j].SubcategoryComment
                tmpObj.subcategoryid   = duplicateCategory[j].SubcategoryId
                tmpObj.specsname      = addObsoletedKanji( duplicateCategory[j], 'Specs' ) //2025-04-25 jazz, add discontinued kanji
                tmpObj.specscomment   = duplicateCategory[j].SpecsComment
                tmpObj.specsid        = duplicateCategory[j].SpecsId
                tmpObj.texturename    = addObsoletedKanji( duplicateCategory[j], 'Texture' ) //2025-04-25 jazz, add discontinued kanji
                tmpObj.texturecomment = duplicateCategory[j].TextureComment
                tmpObj.textureid       = duplicateCategory[j].TextureId
                tmpObj.rowindex        = duplicateCategory[j].RowIndex
                tmpObj.maincategoryistexture   = duplicateCategory[j].istexture //maincategory
                tmpObj.categoryistexture       = duplicateCategory[j].categoryisTexture //category
                tmpObj.subcategoryistexture    = duplicateCategory[j].subcategoryisTexture //subcategory
                tmpObj.specsistexture          = duplicateCategory[j].specsisTexture //specs
                  
                tmpCategory.push(tmpObj)
                tmpCategory.sort(generateSortFn([{name: 'sortno', reverse: false}, {name: 'subcategorysortno', reverse: false}, {name: 'specssortno', reverse: false}]));

                if(duplicateCategory[j].Modified){
                    item.ismodified = duplicateCategory[j].Modified
                    item.bgcolor  = '#ffffb3'
                }

                item.category = tmpCategory
                tmpArr.push(duplicateCategory[j].RowIndex)
            }
        })

        // result.sort((a, b) => (a.sortno > b.sortno) ? 1 : (a.sortno === b.sortno) ? ((a.name > b.name) ? 1 : -1) : -1 )
		
        //modify by mae 2025-04-29
        result.sort((a, b) => {
            if (a.sortno !== b.sortno) {
                return a.sortno - b.sortno;
            }
        
            const matchA = a.name.match(/\d+/);
            const matchB = b.name.match(/\d+/);
            const numA = matchA ? parseInt(matchA[0]) : 0;
            const numB = matchB ? parseInt(matchB[0]) : 0;
            return numA - numB;

        });

        let gaibuList = [];
        let setsubiList = [];
        let kihonList = [];


        for (let i = 0; i < result.length; i++) {
            switch(result[i].masterid){
                case 1: gaibuList.push(result[i]); break;
                case 2: setsubiList.push(result[i]); break;
                case 3: kihonList.push(result[i]); break;
            }
        }

        for(let i = 0; i < gaibuList.length; i++){
            gaibuList[i].rowcount = i + 1;
        }

        for(let i = 0; i < setsubiList.length; i++){
            setsubiList[i].rowcount = i + 1;
        }

        for(let i = 0; i < kihonList.length; i++){
            kihonList[i].rowcount = i + 1;
        }

        return gaibuList.concat(setsubiList, kihonList);
    }
  
    static formatDisplay = (texture) =>{
      let tmpData = ''
      if (texture) {
          tmpData = texture.replace('●', '')
          if (texture.includes('※')) {
              if ( /^※/.test(texture)) {
                  tmpData = texture
              } else {
                  tmpData = tmpData.split('※')[0]
              }
          }
      } else {
          tmpData = '<center>--</center>'
      }
      return tmpData     
    }

    static SetKindDetails = (category, payload, updateKind, routename) =>{
        let itemObj = {}
        let masterId = 0
 
        switch(routename){
            case 'GaibuList'   : masterId = 1; break;
            case 'SetsubiSheet': masterId = 2; break;
            case 'BasicSpecs'  : masterId = 3; break;
        }
 
        for (let i = 0; i < store.state.UserInterface[routename].length; i++) {
            if (store.state.UserInterface[routename][i].items == category) {
                itemObj.sheet        = routename;
                itemObj.itemToUpdate = updateKind;
                itemObj.value        = payload
                itemObj.category     = category
                itemObj.index        = i;
                itemObj.index        = i;
                itemObj.modified     = false;
            
 
                store.dispatch('UpdateInterfaceItem', itemObj)
                for (let j = 0; j < store.state.PlanInfo.SelectedItems.length; j++) {
                    if(masterId == store.state.PlanInfo.SelectedItems[j].MasterId){
                        if(store.state.PlanInfo.SelectedItems[j].Floor != 0){
                            if (store.state.PlanInfo.SelectedItems[j].MainCategoryName == store.state.UserInterface[routename][i].items) {
                                let tmpObj = {}

                                switch (updateKind) {
                                    case 'roomname': tmpObj.itemToUpdate = 'RoomName'; break;
                                    case 'floor': tmpObj.itemToUpdate = 'Floor'; break;
                                    case 'hinban': tmpObj.itemToUpdate = 'Hinban'; break;
                                    case 'itemnumber': tmpObj.itemToUpdate = 'ItemNumber'; break;
                                }

                                tmpObj.value        = payload;
                                tmpObj.index        = j;
                                tmpObj.modified     = store.state.PlanInfo.SelectedItems[j].Modified;
                                store.dispatch('UpdatePlanInfoItem', tmpObj)


                            }
                        }
                    }
                }
            }
        }
    }
	
    //added mae 2025-01-21 - separate function for aircon number restriction
    static SetKindDetails_ItemNumber = (category, payload, updateKind, routename, airconNumberList) =>{
        let itemObj = {}
        let masterId = 0

        switch(routename){
            case 'GaibuList'   : masterId = 1; break;
            case 'SetsubiSheet': masterId = 2; break;
            case 'BasicSpecs'  : masterId = 3; break;
        }

        for (let i = 0; i < store.state.UserInterface[routename].length; i++) {
            if (store.state.UserInterface[routename][i].items == category) {
                itemObj.sheet        = routename;
                itemObj.itemToUpdate = updateKind;
                itemObj.value        = payload
                itemObj.category     = category
                itemObj.index        = i;
                itemObj.modified     = false;

                store.dispatch('UpdateInterfaceItem', itemObj)
                for (let j = 0; j < store.state.PlanInfo.SelectedItems.length; j++) {
                    if(masterId == store.state.PlanInfo.SelectedItems[j].MasterId){
                        if(store.state.PlanInfo.SelectedItems[j].Floor != 0){
                            if (store.state.PlanInfo.SelectedItems[j].MainCategoryName == store.state.UserInterface[routename][i].items) {
                                let tmpObj = {}

                                switch (updateKind) {
                                    case 'roomname': tmpObj.itemToUpdate = 'RoomName'; break;
                                    case 'floor': tmpObj.itemToUpdate = 'Floor'; break;
                                    case 'hinban': tmpObj.itemToUpdate = 'Hinban'; break;
                                    case 'itemnumber': tmpObj.itemToUpdate = 'ItemNumber'; break;
                                }

                                tmpObj.value        = payload;
                                tmpObj.index        = j;


                                //--Added mae 2025-01-21 => to restrict the multiple airconnumber--//

                                 // Check if the ItemNumber is already selected
                                const isSelected = store.state.PlanInfo.SelectedItems.some(item =>
                                    item[tmpObj.itemToUpdate] === tmpObj.value && item.MasterId === masterId
                                );

                                // If the ItemNumber is not already selected, add it to airconNumberList
                                if (!isSelected) {
                                    airconNumberList.push(tmpObj.value); // Add the new ItemNumber to airconNumberList
                                }

                                // If the ItemNumber is already in airconNumberList, it will remove to list
                                const index = airconNumberList.indexOf(itemObj.value);
                                if (index !== -1) {
                                    airconNumberList.splice(index, 1); // Remove the ItemNumber in list
                                }

                                //----------------------End---------------------------------------//

                                tmpObj.modified     = store.state.PlanInfo.SelectedItems[j].Modified;
                                store.dispatch('UpdatePlanInfoItem', tmpObj)
                            }
                        }
                    }
                }    
            }
        }  
    }
	
    static SetMenuItems = async () =>{


        const menuItems = await this.axiosObj.get(`${process.env.MIX_API_BASEURL}/api/menuitems`)

        menuItems.data.forEach(item => {
            if (item.isavailableintrial == 0 && !this.isDebugMode() ){
                item.backcolor = 'grey'
            }
        })
        store.dispatch('MenuItems', menuItems.data)
    }

    static SetColspan = (jsonArr, colnumtoadd) =>{
        let colspan = 0;

        if (typeof(jsonArr.textureList) === 'undefined' || jsonArr.textureList.length == 0) {
            colspan = colnumtoadd
        }

        if (jsonArr.specs) {
            colspan = 1
        }

        if(this.Const.TOILETS_CATEGORY_ID_RETAINOBJ.includes(jsonArr.id) && jsonArr.groupid == 2){
            // if(process.env.MIX_DEBUG == 'true'){
                colspan = colnumtoadd           
            // }else{
                // colspan = 3
            // }
        }else{
            if(jsonArr.istexture != 1){
                colspan = 1    
            }
        }
        
      // if(jsonArr.id == 4759){
      //       colspan = 3
        
      //       console.log(jsonArr.items + '==' + colspan)
            
      //   } 

        return colspan
    }

    static GetParentCheckbox = (maincategory, parentid) =>{
        let tmpArr = []
        let tmpObj = {}
        let tmpObj1 = {}
        let result = {}

        maincategory.category.forEach(category =>{
            if ( category.id == parentid ){
                tmpObj = category.category
            }

            if ( category.subcategory ){   
                category.subcategory.forEach(subcategory =>{
                    if (subcategory.id == parentid ){
                        tmpObj = subcategory
                    }

                     if (subcategory.specs){

                        subcategory.specs.forEach(spec =>{
                            if (spec.id == parentid ){
                                tmpObj = spec 
                            }
                        })
                   }
                })
            }            
        })

        if ( tmpObj ){
            if (tmpObj.ischeckbox == 0){
                maincategory.category.forEach( category =>{
                    if (category.id == tmpObj.parentid ){
                        tmpObj1 = category
                    }

                    if (category.subcategory){
                        category.subcategory.forEach(subcategory =>{
                            if(subcategory.id == tmpObj.parentid){
                                tmpObj1 = subcategory
                            }
                        })
                    }
                })
            }

            tmpArr = [tmpObj, tmpObj1]
            tmpArr.forEach(item =>{
                if(item.ischeckbox == 1){
                    result = item
                }
            })
        }
        return result
    }

    static generatePDF = async (data, isFile) => {
        const { jsPDF } = await import("jspdf"); //2025-08-15 jazz
        const { autoTable } = await import("jspdf-autotable"); //2025-08-15 jazz

        const fontAsBase64 = this.fontAsBase64

        var callAddFont = function () {
            this.addFileToVFS("SourceHanSansCN-Regular-normal.ttf", fontAsBase64);
            this.addFont("SourceHanSansCN-Regular-normal.ttf", "SourceHanSansCN-Regular", "normal");
        };

        jsPDF.API.events.push(['addFonts', callAddFont])

        const constructionCode = store.state.PlanInfo.ConstructionCode;
        const revisionNo       = store.state.PlanInfo.RevisionNumber;
        const requestNo        = store.state.PlanInfo.RequestNumber;
        const houseType        = store.state.PlanInfo.HouseType;
        const fileName         = `${constructionCode}-${revisionNo}-${requestNo}.pdf` 
        const tmpcopiedPlanNumber = store.state.PlanInfo.JibanInfo.CopiedPlanInfo ? store.state.PlanInfo.JibanInfo.CopiedPlanInfo.RevisionNumber + '-' + store.state.PlanInfo.JibanInfo.CopiedPlanInfo.RequestNumber : '';
        const doc              = new jsPDF({ orientation: "portrait", compress: true });
        const masterNames      = ['外部 シート-', '設備 シート-', '基本仕様'];
		let tmpCommentArr      = [];

        function getHeader(){
            let result = []
            let header = ['番号', '部位', '部屋名', '部位', '商品・品番', 'メーカー', '色']

            header.forEach(item =>{ 
                                let tmpObj = {}
                                tmpObj.content = item
                                result.push(tmpObj)
                            })
            return result
        }

        function formattedComment(comment){
            let result = ''
            const tmpHouseType = store.state.Master.HouseTypes.filter(item => item.HouseType == store.state.PlanInfo.HouseType)[0]
            let isCopyCommentObj = false;
            let formatComment = '';

            if(Array.isArray(comment)){
                for(let i = 0; i < comment.length; i++){
                    if(comment[i].houseapplicable){
                        if(!comment[i].houseapplicable.includes( parseInt(tmpHouseType.Id))) continue;
                    }

                    let tmpComment = comment[i].comment ? comment[i].comment: comment[i]

                    if(comment[i].color){
                        tmpComment = comment[i].comment ? comment[i].comment: comment[i]
                        
                        if(comment[i].color === 'blue'){
                            isCopyCommentObj = true; 
                            formatComment = comment[i].comment;
                        }    
                    }


                    if(/^\(.{2,}[\)|）]$/.test(tmpComment)){
                        result = `${result}\n${tmpComment.trim()}` 

                    }else{
                        result = `${result}\n※${tmpComment.trim()}` 
                    }
                }
            }

            if(isCopyCommentObj){
                tmpCommentArr.push(formatComment) ;
            }
            
            return result;     
        } 

        function formattedTableBody(){
            //mae added for bgcolor item that with changes only
            function isModifiedItem(maincategory, rowindex){
                let result = false;

                store.state.PlanInfo.SelectedItems.map(planInfo => {
                    if(planInfo.MainCategoryName === maincategory.name && planInfo.RowIndex === rowindex && planInfo.Modified){
                        result = true;
                    }
                })

                return result;
            }

            try{
                let tableBody = [];
                for (let i = 0; i < masterNames.length; i++) {
                    tableBody.push( [{ content: masterNames[i], colSpan: 7, styles: { halign: 'center', fillColor: [242, 242, 242], fontSize: 9 }}] )
                    for (let j = 0; j < data.length; j++) {
                        if (data[j].masterid == (i + 1)) {
                            let rowspan = (data[j].category && data[j].category.length > 0) ? data[j].category.length:1
                            let roomDetails = ''

                            if ( data[j].floor != 0 && data[j].floor && data[j].floor != ''){
                                roomDetails = roomDetails + data[j].floor

                                if (data[j].room != 0 && data[j].room && data[j].room != '') {
                                    roomDetails = roomDetails + "\n" + data[j].room
                                }

                                if (data[j].hinban != 0 && data[j].hinban && data[j].hinban != '') {
                                    roomDetails = roomDetails + "\n" + data[j].hinban
                                }

                                //2023-12-13
                                if (data[j].itemnumber != 0 && data[j].itemnumber && data[j].itemnumber != '') {
                                    roomDetails = roomDetails + "\n" + data[j].itemnumber
                                }
                            }

                            let maincategorycomment = formattedComment(data[j].comment);
                            let categorycomment = formattedComment(data[j].category[0].categorycomment);
                            let subcategorycomment = formattedComment(data[j].category[0].subcategorycomment);
                            let specscomment = formattedComment(data[j].category[0].specscomment);
                            let texturecomment = formattedComment(data[j].category[0].texturecomment);

                            let tmpFillColor = (!data[j].category[0].texturename && data[j].category[0].categoryistexture != 1 && 
                                        data[j].category[0].subcategoryistexture != 1 && data[j].category[0].specsistexture != 1 || 
                                        !data[j].category[0].name && !data[j].category[0].subcategoryname && !data[j].category[0].specsname && 
                                        !data[j].category[0].texturename)? true:false;

                            let ismodifiedColor = data[j].ismodified? true: false; 

                            tableBody.push([
                                              {content: data[j].rowcount, styles: { minCellWidth:10 }, rowSpan: rowspan, modifiedColor:ismodifiedColor}, 
                                              {content: data[j].name + maincategorycomment, rowSpan: rowspan, modifiedColor:ismodifiedColor},
                                              {content: (roomDetails == '' ? '--':roomDetails),  rowSpan: rowspan, styles:{fillColor: ismodifiedColor}}, 
                                              {content: (data[j].category[0].name ? data[j].category[0].name.replace(/<p>/, "\n") + categorycomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[0].rowindex)},
                                              {content: (data[j].category[0].subcategoryname ? data[j].category[0].subcategoryname.replace(/<p>/, "\n") + subcategorycomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[0].rowindex)},
                                              {content: (data[j].category[0].specsname ? data[j].category[0].specsname.replace(/<p>/, "\n") + specscomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[0].rowindex)},
                                              {content: (data[j].category[0].texturename ? data[j].category[0].texturename.replace(/<p>/, "\n") + texturecomment:'--'), rowSpan: 1, nunmodifiedColor: tmpFillColor, modifiedColor:isModifiedItem(data[j], data[j].category[0].rowindex) }
                                           ])

                            for (let k = 0; k < data[j].category.length; k++) {
                                if (k > 0) {
                                    // let categorycomment = data[j].category[k].categorycomment ? "\n※" + data[j].category[k].categorycomment.replace(/<p>/, " "):'';
                                    // let subcategorycomment = data[j].category[k].subcategorycomment ? "\n※" + data[j].category[k].subcategorycomment.replace(/<p>/, " "):'';
                                    // let specscomment = data[j].category[k].specscomment ? "\n※" + data[j].category[k].specscomment.replace(/<p>/, " "):'';
                                    // let texturecomment = data[j].category[k].texturecomment ? "\n※" + data[j].category[k].texturecomment.replace(/<p>/, " "):'';

                                    let categorycomment = formattedComment(data[j].category[k].categorycomment);
                                    let subcategorycomment = formattedComment(data[j].category[k].subcategorycomment);
                                    let specscomment = formattedComment(data[j].category[k].specscomment);
                                    let texturecomment = formattedComment(data[j].category[k].texturecomment);

                                    let tmpFillColor  = (!data[j].category[k].texturename && data[j].category[k].categoryistexture != 1 && 
                                                    data[j].category[k].subcategoryistexture != 1 && data[j].category[k].specsistexture != 1 || 
                                                    !data[j].category[k].name && !data[j].category[k].subcategoryname && !data[j].category[k].specsname 
                                                    && !data[j].category[k].texturename)? true:false;

                                     tableBody.push([
                                                       {content: (data[j].category[k].name ? data[j].category[k].name.replace(/<p>/, "\n") + categorycomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[k].rowindex)},
                                                       {content: (data[j].category[k].subcategoryname ? data[j].category[k].subcategoryname.replace(/<p>/, "\n") + subcategorycomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[k].rowindex)},
                                                       {content: (data[j].category[k].specsname ? data[j].category[k].specsname.replace(/<p>/, "\n") + specscomment:'--'),  rowSpan: 1, modifiedColor:isModifiedItem(data[j], data[j].category[k].rowindex)},
                                                       {content: (data[j].category[k].texturename ? data[j].category[k].texturename.replace(/<p>/, "\n") + texturecomment:'--'),  rowSpan: 1, nunmodifiedColor: tmpFillColor, modifiedColor:isModifiedItem(data[j], data[j].category[k].rowindex)}
                                                    ])
                                }
                            }
                        }
                    }
                }
                return tableBody
            }catch(err){
                this.Logger('error', store.state.UserInfo.FullName, 'SRSFunction.js', `error formatting pdf body ${store.state.PlanInfo.ConstructionCode} ${store.state.PlanInfo.RevisionNumber} ${store.state.PlanInfo.RequestNumber}`, 1)    
            }
        }

        function getTotalPages(){
            try{
                let totalPagesExp = 0;
                let doc1 = new jsPDF({orientation: "portrait", unit: 'pt' });
                doc1.autoTable({ 
                                          head: [ getHeader() ],
                                          didDrawPage: function (data) {
                                              doc1.setFont("SourceHanSansCN-Regular", "normal");
                                              doc1.setFontSize(9);
                                              doc1.text("お客様コード:", 10, 10);
                                              totalPagesExp = doc1.internal.getNumberOfPages();
                                          },
                                          headStyles: {
                                              minCellWidth:10,      
                                              fontSize: 9,
                                              font: 'SourceHanSansCN-Regular',
                                              fontStyle: 'normal',
                                          },
                                          body: formattedTableBody(), 
                                          margin: { top: 12, bottom: 8, right: 5, left: 5 },
                                          styles: { halign: 'left', font: 'SourceHanSansCN-Regular', fontStyle: 'normal', fontSize: 7 },
                                        });
                doc1 = null
                return totalPagesExp;
            }catch(err){
                this.Logger('error', store.state.UserInfo.FullName, 'SRSFunction.js', `error getting total page of pdf ${store.state.PlanInfo.ConstructionCode} ${store.state.PlanInfo.RevisionNumber} ${store.state.PlanInfo.RequestNumber}`, 1)    
            }
        }

        try{
            let comment = '';
            let textDimension = 0;
            let countItem = 0;

            doc.autoTable({ 
                            head: [ getHeader() ],
                            showHead: "everyPage",

                            willDrawCell: function (data) {  
                                if(data.cell.raw.nunmodifiedColor){
                                    doc.setFillColor(255,205,255);
                                } 

                                if(data.cell.raw.modifiedColor){
                                    doc.setFillColor(255,255,179);
                                } 

                                if(/※/.test(data.cell.raw.content) || /.{2,}\n\(.{2,}[\)|\）]$/.test(data.cell.raw.content)){
                                    var str = data.cell.raw.content.includes('\n') ? data.cell.raw.content.split('\n') : data.cell.raw.content;

									//added mae 2025-04-10
                                    if(!Array.isArray(str)){
                                        const splitIndex = Math.floor(doc.splitTextToSize(str, data.cell.width - 3, 0));
                                        
                                        // Insert a newline character at the determined position
                                        comment = str.slice(0, splitIndex) + '\n' + str.slice(splitIndex);
  
                                        // Remove text to assign new comment with color
                                        data.cell.text = data.cell.text.filter((item, index) => {
                                            return index < data.cell.text.findIndex((element) => element.includes('※'));
                                        });
                                    }


                                    if(data.cell.text.length > 1){
                                        comment = '';

                                        for(let i = 0; i < str.length; i++){
                                            if(i > 0){
                                                comment = `${comment}${str[i]}\n`
                                            }
                                        }

                                        //data.cell.text = data.cell.text[0];

                                        //mae added 2024-10-31 => split text if excess to cell width
                                        data.cell.text = doc.splitTextToSize(str[0], data.cell.width - 3 , 0);

                                    }else if(data.cell.text.length == 1){
                                        comment = data.cell.text[0].replace(data.cell.text[0], str[0])

                                        //remove text to assign new comment with color
                                        data.cell.text = data.cell.text.filter((item, index) => {
                                            return index < data.cell.text.findIndex((element) => element.includes('※'));
                                        });
                                    }
									
									
                                    // mae added 2024-10-31 => Check if the comment is empty
                                    if (comment.trim() === '') {
                                        comment = str;
                                    } 


                                    // if(data.cell.text.length > 1){
                                    //     comment = data.cell.text[1].replace(data.cell.text[1], str[1])
                                    //     if(data.cell.text.length > 2){
                                    //         if(str[2]){
                                    //             comment = comment + '\n' + data.cell.text[1].replace(data.cell.text[1], str[2]) 
                                    //         }
                                    //     }

                                    //     data.cell.text = data.cell.text[0]

                                    // }else if(data.cell.text.length == 1){
                                    //     comment = data.cell.text[0].replace(data.cell.text[0], str[0])

                                    //     //remove text to assign new comment with color
                                    //     data.cell.text = data.cell.text.filter((item, index) => {
                                    //         return index < data.cell.text.findIndex((element) => element.includes('※'));
                                    //       });

                                    // }
                                }

                                //2025-04-25 jazz
                                if( /\[廃番\]/.test(data.cell.raw.content) ){
                                    if( Array.isArray( data.cell.text ) ){
                                        let idx = null;

                                        for( let l = 0; l < data.cell.text.length; l++ ){
                                            if( !data.cell.text[l ].includes('[廃番]') ) continue;

                                            data.cell.text[l] = data.cell.text[l].replace('[廃番]','');
                                            idx = l; 
                                        }
 
                                        data.cell.addObsoleteKanji = true;
                                        data.cell.text[idx + 1] = ' ';
                                    }
                                }
                            }, 

                            //2025-04-25 jazz, add padding when added obsolete kanji
                            didParseCell: function ( data ) {
                                if( /\[廃番\]/.test( data.cell.raw.content ) ){
                                    data.cell.styles.minCellHeight = data.cell.styles.minCellHeight + 17
                                }                            
                            },

                            didDrawCell: function (data) {
                                //2025-04-25 jazz
                                if(/\[廃番\]/.test(data.cell.raw.content)){
                                    if( Array.isArray( data.cell.text ) && data.cell.addObsoleteKanji ){
                                  
                                        for( let l = 0; l < data.cell.text.length; l++ ){
                                            if( data.cell.text[l] != ' ' ) continue;

                                            doc.setTextColor("red");
                                            doc.text( '[廃番]', data.cell.x + 2, data.cell.y  + doc.getTextDimensions(data.cell.text).h + 1.5 );
                                        }
                                    }
                                }

                                if(/※/.test(data.cell.raw.content) || /.{2,}\n\(.{2,}[\)|\）]$/.test(data.cell.raw.content)){
                                    try{   
                                            //width and height of the text to be added (add 2 for text padding)
                                            const textHeight = doc.getTextDimensions(data.cell.text).h + 2;
                                            const textCommentHeight = doc.getTextDimensions(comment).h; 

                                            //x coordinate for the comment
                                            const x = data.cell.x + 2; 

                                            //y coordinate for the first comment
                                            let y = data.cell.y + textHeight + textCommentHeight;

                                            // Calculate the width of the comment text to fit within the table cell
                                            let textWidth = doc.getStringUnitWidth(comment) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                                
                                            const comments = comment.split(/※/).map(c => c.trim()).filter(c => c.length > 0);

                                            comments.forEach((singleComment) => {
                                                if (tmpCommentArr.includes(singleComment)) {
                                                    singleComment = '※'+singleComment;
                                                    doc.setTextColor("blue");
                                                } else {
                                                    singleComment = '※'+singleComment;
                                                    doc.setTextColor("red");
                                                }

                                                // Check if the comment width exceeds the cell width
                                                if (Math.floor(textWidth) >= Math.floor(data.cell.width)) {

                                                    const splitComment = doc.splitTextToSize(singleComment, data.cell.width - 3, 0);
                                                    
                                                    splitComment.forEach(line => {
                                                        doc.text(line, x, y);
                                                        y += textCommentHeight; //Increment y for the next line to Adjust y position
                                                    });
                                                } else {

                                                    doc.text(singleComment, x, y);
                                                    y += textCommentHeight; // Increment y for the next comment
                                                }

                                            });


                                    }catch(e){
                                        console.log(e)
                                    }
                                }
                            },
                            
                            didDrawPage: function (data) {
                                function convertDateTime(time){
                                    const unixTimeZero = Date.parse(time);
                                    let timeZone = 'Asia/Tokyo'

                                    if((/hrd/i).test(process.env.MIX_DEPLOYMENT)){
                                        timeZone = 'Asia/Singapore'   
                                    }

                                    const sentDateTime = new Date(unixTimeZero).toLocaleString('af-ZA', {timeZone: timeZone, dateStyle: 'short', timeStyle: 'short', hour12: false })
                                    return sentDateTime
                                }

                                let pdfDate = new Date().toLocaleString()

                                //added Mae 2026-07-14. current date and time if previoussentdate is empty.
                                if(store.state.PlanInfo.CurrentMenu == '作成(Create)' && store.state.PlanInfo.PreviousSentDate == ''){
                                    pdfDate = convertDateTime(pdfDate)
                                }else{
                                    pdfDate = store.state.PlanInfo.PreviousSentDate
                                }
								
                                doc.setFont("SourceHanSansCN-Regular", "normal");
                                
                                //optimized by mae 2025-02-25
                                let countAddSpace = tmpcopiedPlanNumber ? ("コピー元:".length * 2)  + (`${tmpcopiedPlanNumber}`.length * 2) + ( houseType.length > 16 ? 0 : 3 )  : 5;
                                let housetypeLn = houseType.length > 16 ? houseType.length * 2 : houseType.length < 7 ? houseType.length * 2.3: houseType.length * 1.8;

                                doc.setFontSize(7);
                                doc.text("お客様コード:", 5, 10);
                                doc.text("図面番号:", 5 + ("お客様コード:".length * 1.5) + (`${constructionCode}`.length *2), 10);
                                doc.text("仕様書番号:", 5 + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2) 
                                                         + ("図面番号:".length * 2) + (`${revisionNo}`.length * 2), 10);
                                doc.text("家タイプ:", 5 + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2) 
                                                        + ("図面番号:".length * 1.5) + (`${revisionNo}`.length * 2) 
                                                        + ("仕様書番号:".length * 3) + (`${requestNo}`.length * 2), 10);

                                tmpcopiedPlanNumber ? doc.text("(コピー元:", 5    + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2) 
                                                                    + ("図面番号:".length * 1.5) + (`${revisionNo}`.length * 2)
                                                                    + ("仕様書番号:".length * 2 ) + (`${requestNo}`.length * 2)
                                                                    + ("家タイプ:".length * 3) + (housetypeLn)
                                                                    , 10):''; //added mae 2025-02-21  

                                doc.text("日時:", 5 + ("お客様コード:".length  *1.5) + (`${constructionCode}`.length * 2)
                                                     + ("図面番号:".length *1.5) + (`${revisionNo}`.length * 2) 
                                                     + ("仕様書番号:".length * 2) + (`${requestNo}`.length * 2)
                                                     + ("家タイプ:".length * 3) + (housetypeLn)
                                                     + countAddSpace, 10);
 
                                doc.setTextColor("blue");
                                doc.text(constructionCode, (doc.getTextWidth('お客様コード: ') + 5), 10);
                                doc.text(revisionNo, (doc.getTextWidth('図面番号: ') + 5 + ("お客様コード:".length * 1.5) + (`${constructionCode}`.length *2)), 10);
                                doc.text(requestNo, (doc.getTextWidth('仕様書番号: ') + 5 + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2) 
                                                                                          + ("図面番号:".length * 2) + (`${revisionNo}`.length * 2) ), 10);
                                doc.text(houseType, (doc.getTextWidth('家タイプ: ') + 5 + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2) 
                                                                                        + ("図面番号:".length * 1.5) + (`${revisionNo}`.length * 2)
                                                                                        + ("仕様書番号:".length * 3) + (`${requestNo}`.length * 2)), 10);

                                
                                if( tmpcopiedPlanNumber ){ 
                                    doc.text(`${tmpcopiedPlanNumber}`, (doc.getTextWidth('( コピー元:') + 5 + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2)
                                                                                                                + ("図面番号:".length * 1.5) + (`${revisionNo}`.length * 2)
                                                                                                                + ("仕様書番号:".length * 2) + (`${requestNo}`.length * 2)
                                                                                                                + ("家タイプ:".length * 3) + (housetypeLn) 
                                                                                                                 ), 10);
                                    
                                    doc.setTextColor("black");
                                    doc.text(`)`, (doc.getTextWidth('(コピー元:') + 5.5  + ("お客様コード:".length * 1.5 ) + (`${constructionCode}`.length * 2)
                                                                                        + ("図面番号:".length * 1.5) + (`${revisionNo}`.length * 2)
                                                                                        + ("仕様書番号:".length * 3) + (`${requestNo}`.length * 2)
                                                                                        + ("家タイプ:".length * 3) + (housetypeLn)
                                                                                        ), 10);
                                } 

                                doc.setTextColor("blue");
                                if(store.state.Referrer == 'CadRequestSystem'){
                                    doc.text('作成(Create) ' + pdfDate, (doc.getTextWidth('日時: ') + 5 + ("お客様コード:".length *1.5 ) + (`${constructionCode}`.length * 2)
                                                                                                         + ("図面番号:".length *1.5) + (`${revisionNo}`.length * 2)
                                                                                                         + ("仕様書番号:".length *2) + (`${requestNo}`.length * 2) 
                                                                                                         + ("家タイプ:".length * 3) + (housetypeLn) 
                                                                                                         + countAddSpace), 10);
                                }else{
                                    doc.text(store.state.PlanInfo.CurrentMenu + ' ' + pdfDate, (doc.getTextWidth('日時: ') + 5 + ("お客様コード:".length *1.5 ) + (`${constructionCode}`.length * 2)
                                                                                                                                + ("図面番号:".length *1.5) + (`${revisionNo}`.length * 2)
                                                                                                                                + ("仕様書番号:".length *2) + (`${requestNo}`.length * 2)
                                                                                                                                + ("家タイプ:".length * 3) + (housetypeLn) 
                                                                                                                                + countAddSpace), 10);
                                }

                                doc.setTextColor("black");

                                // Footer
                                var str = doc.internal.getNumberOfPages()

                                if (typeof doc.putTotalPages === 'function') {
                                    str = str + " / " + getTotalPages();
                                }
                                              
                                doc.setFontSize(7);
                                // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                                var pageSize = doc.internal.pageSize;
                                var pageWidth = pageSize.width;
                                var pageHeight = pageSize.height ? pageSize.height:pageSize.getHeight();
                                doc.text(str, pageWidth / 2, pageHeight - 5);
                            },
                            headStyles: {
                                minCellWidth:10,
                                lineWidth: 0.5,
                                halign: 'center',    
                                fontSize: 9,
                                fillColor: [25, 118, 210], //blue
                                textColor: [255, 255, 255], //white 
                                font: 'SourceHanSansCN-Regular',
                                fontStyle: 'normal',
                            },
                            body: formattedTableBody(), 
                            theme: "grid", 
                            margin: { top: 12, bottom: 8, right: 5, left: 5 },
                            styles: {
                                        halign: 'left',
                                        font: 'SourceHanSansCN-Regular',
                                        fontStyle: 'normal',
                                        //textColor: [78, 53, 73], //Black 
                                        fontSize: 7,
                                    },

                            rowPageBreak: 'avoid', //2025-04-22 added mae => Prevent row from breaking across pages
                        });
            
            //Save as file or blob
            if(isFile){
                doc.save(fileName);  
                this.Logger('info', store.state.UserInfo.FullName, 'SRSFunction.js', `success creating pdf ${store.state.PlanInfo.ConstructionCode} ${store.state.PlanInfo.RevisionNumber} ${store.state.PlanInfo.RequestNumber}`, 1)   
                return true;
            }else{
                const blob = doc.output('blob')

                let formData = new FormData();

                await formData.append("details", fileName);
                await formData.append('file', blob);
 
                // const result = await axios.post(`/api/upload-blob`, formData, { //no need to await,
                //     headers: {
                //         'Content-Type': 'multipart/form-data'
                //     }
                // })

                //2025-09-18 jazz
                let blobURI = '/api/upload-blob';

                //commented 2026-07-14 jazz
                // if(process.env.MIX_DEBUG == 'true'){
                //     blobURI = 'https://srs.hrd-s.com/api/upload-blob'   
                // }
 
                const result = await this.axiosObj.post(blobURI, formData, { //no need to await,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
 
                return true;
            } 
        }catch(err){
            this.Logger('error', store.state.UserInfo.FullName, 'SRSFunction.js', `error creating pdf ${store.state.PlanInfo.ConstructionCode} ${store.state.PlanInfo.RevisionNumber} ${store.state.PlanInfo.RequestNumber}`, 1)        
            return false
        }
    }

    static gotToSpecificView = async (sheet, textureObj, progressBar = null) =>{
        // store.dispatch('isCategoryOnly', false)
        // bus.$emit('resetDisplay')

        if (!textureObj.kind) {
            store.dispatch('EditKey', textureObj.items)
        } else {
            store.dispatch('EditKey', textureObj.kind)
        }  

        if (textureObj == '-1') {
            store.dispatch('EditKey', '-1')
        }

        this.setActiveSheetInViewAndIDB(sheet, progressBar)
    }

    static getSheetItems = async () =>{
        const res = await this.axiosObj.get(`${process.env.MIX_API_BASEURL}/api/masters`);
        store.dispatch('sheetItems', res.data.sort((a, b) => a.sortno - b.sortno ) )
    }

    static setActiveSheetInViewAndIDB = async (sheet, progressBar = null, isLogged = true, isUserTriggered = false) => {
        async function incrementProgressBar(isUserTriggered, progressBar){
            if(isUserTriggered){
                if(progressBar){
                    progressBar.increment();
                }
            }     
        }

        try{
            if(!sheet) return;

            if(!isUserTriggered){
                store.dispatch('updateSheetItems', sheet)    
            }

            if(router.currentRoute.name != sheet.englishname){
                await incrementProgressBar(isUserTriggered, progressBar)
                //2026-09-29 jazz, await the navigation - callers (e.g. handlePrimary in
                //SpawnConvertWebWorkers) rely on this resolving before they consider the target sheet
                //"displayed" and hide their own loading overlay. Unawaited, router.push only *starts* the
                //navigation (including fetching the target sheet's lazy-loaded chunk), so the overlay could
                //close while the page was still blank.
                await router.push(sheet.englishname)

                this.Logger(
                    'info', 
                    store.state.UserInfo.FullName, 
                    'SRSFunction.js', `Tabsheet ${sheet.japanesename} opened`, 
                    1
                )
                
                await incrementProgressBar(isUserTriggered, progressBar)
            }
        }catch(err){
            if(progressBar){
                progressBar.hide();
            }

            this.Logger('error', store.state.UserInfo.FullName, 'SRSFunction.js', err.message.replace(new RegExp('\r?\n','g'), '_'), 1)   
        }
    }

    static SetModifiedItems = (indexinstore) =>{
        if (indexinstore == -1) return 0;
        let itemObj = {}
        itemObj.itemToUpdate = 'Modified'; 
        itemObj.value        = true
        itemObj.index        = indexinstore;
        store.dispatch('UpdatePlanInfoItem', itemObj)
    }

    static isHRDMode = () =>{
        let tmpResult = null
        if ((/hrd/i).test(process.env.MIX_DEPLOYMENT)) {
            tmpResult = true  
        } else if ((/ichijo/i).test(process.env.MIX_DEPLOYMENT)) {
            tmpResult = false
        } else {
            // alert('please check deployment mode')
            let text = "展開モードを確認してください \nplease check deployment mode"
            this.$swal({
                text:text,
                icon:"warning",
                className:"swalError",
                closeOnClickOutside:false,
                buttons:{
                    text:"ok",
                    className:"swalconfirm"
                }
            }).then((confirm)=>{
                if(confirm){
                    window.close()
                }
            }) 
        }
        return tmpResult
    }

    static mode = () =>{
        return process.env.MIX_DEPLOYMENT
    }

    //2025-08-22 jazz
    // static showDebugMessage = ( functionname, message ) =>{
    //     if(process.env.MIX_DEPLOYMENT == 'hrd' && process.env.MIX_DEBUG){
    //         console.log(`${functionname}: ${message}`)
    //     }
    // }

    static isDebugMode = () => {
        result = false;

        if( process.env.MIX_DEBUG == 'true' ){
            result = true;
        }
        return result;
    }

    static evntChangeTDBackground = ( instance ) =>{
        bus.$on('changeTDBackground', (data) =>{
            if(data.name == instance.maincategoryObj.name){
                instance.hover = data.ismouseover;
            }
        }) 
    }

    static changeTDBackground = (data, name ) =>{
        let tmpObjParam = {}
        tmpObjParam.ismouseover = data
        tmpObjParam.name = name

        bus.$emit('changeTDBackground', tmpObjParam);
        return data
    }
    
    // static showItemDetails = ( object, main, cat, subcat, specs, selectedTexture ) => {
    //     let detailStr = '';

    //     if(process.env.MIX_DEPLOYMENT == 'hrd' && process.env.MIX_DEBUG == 'true')
    //     {
    //         let result = null          

    //         if ( object.groupid > 0 ) {
    //             detailStr = `id: ${object.id}\n`+
    //                      `parentid: ${object.parentid}\n`+
    //                      `sortno: ${object.sortno}\n`+
    //                      `isparentcheckbox: ${object.isparentcheckbox}\n`+
    //                      `isedit: ${object.isedit}\n`+
    //                      `isselected: ${object.isselected}\n`+
    //                      `selectionid: ${object.selectionid}\n`+
    //                      `icadtable: ${object.icadtable}\n`+
    //                      `icadtableid: ${object.icadtableid}\n`+
    //                      `housetype: ${object.housetype}`
    //         }else{
    //             detailStr = `id: ${object.id}\n`+
    //                      `folderid: ${object.folderid}\n`+
    //                      `sortno: ${object.sortno}\n`+
    //                      `isparentcheckbox: ${object.isparentcheckbox}\n`+
    //                      `isedit: ${object.isedit}\n`+
    //                      `isselected: ${object.isselected}\n`+
    //                      `selectionid: ${object.selectionid}\n`+
    //                      `icadtable: ${object.icadtable}\n`+
    //                      `icadtableid: ${object.icadtableid}\n`+
    //                      `istexture: ${object.istexture}`
    //         }
    //     }else{
    //         let tmpmain     = main || main != null  ? `${main.items}` + '| ' : '';
    //         let tmpcat      = cat  || cat != null  ? `${cat.items}` + '| ' : '';
    //         let tmpsubcat   = subcat || subcat != null ? `${subcat.items}` + '| ' : '';
    //         let tmpspecs    = specs  || specs != null ? `${specs.items}` + '| ' : '';

    //         if ( object.groupid > 0 ){
    //               if(object.istexture === 1 ){
    //                 if(`${object.items}` === `${selectedTexture}`){
    //                     let fCat = tmpcat === 'undefined| '? '': tmpcat;
    //                     let fsubcat = tmpsubcat === 'undefined| '? '': tmpsubcat;
    //                     let fspecs = tmpspecs === 'undefined| '? '': tmpspecs;

    //                     detailStr =  tmpmain + ' ' + fCat + ' ' + fsubcat + ' ' + fspecs + ' ' + selectedTexture
    //                 }
    //                 else{
    //                     detailStr = `${object.items}`
    //                 }
    //               }else{
    //                     detailStr = `${object.items}`      
    //               }
  
    //         }else{
    //             if(`${object.texturename}` === `${selectedTexture}`){
    //                 detailStr =  tmpmain + ' ' + tmpcat + ' ' +tmpsubcat + ' ' + tmpspecs + ' ' + selectedTexture
    //             }else{
    //                 detailStr = `${object.texturename}`
    //             }
    //         }
    //     }



    //     console.log(detailStr)

    //     return detailStr;
    // }

    //2025-08-22 jazz
    // static SetRoomDetailsOfAllItems = (routename) =>{
    //     let masterId = 0;
    //     switch(routename){
    //         case 'GaibuList'   : masterId = 1; break;
    //         case 'SetsubiSheet': masterId = 2; break; 
    //         case 'BasicSpecs'  : masterId = 3; break;
    //     }

    //     store.state.PlanInfo.SelectedItems.forEach(item =>{
    //         if(item.MasterId == masterId){
    //             if(item.Floor != '0'){
    //                 this.SetKindDetails(item.Kind, item.Floor, 'floor', routename) 
    //                 this.SetKindDetails(item.Kind, item.RoomName, 'roomname', routename) 
    //                 this.SetKindDetails(item.Kind, item.Hinban, 'hinban', routename)   
    //                 this.SetKindDetails(item.Kind, item.ItemNumber, 'itemnumber', routename)   
    //             }
    //         }
    //     })  
    // }

    static GetUniqueValueArray = (arraydata, uniqueidentifier ) =>{
        let result = []

        if(arraydata){
            result = [...new Map(arraydata.map(item => [item[uniqueidentifier], item])).values()]
        }

        return result
    }

    //2025-08-22 jazz
    // static FormattedSRSData = (itemArr, maincategoryname, masterid) =>{
    //     let tmpSiyoDataObj = {}

    //     tmpSiyoDataObj.valueid      = itemArr.id
    //     tmpSiyoDataObj.valuecode    = itemArr.valuecode
    //     tmpSiyoDataObj.categorycode = itemArr.categorycode
    //     tmpSiyoDataObj.maincategory = maincategoryname
    //     tmpSiyoDataObj.masterid     = masterid
    //     tmpSiyoDataObj.selectionid  = itemArr.selectionid //controls the selection
    //     tmpSiyoDataObj.ischeckbox  = itemArr.ischeckbox
    //     tmpSiyoDataObj.groupid = itemArr.groupid

    //     tmpSiyoDataObj.isparentcheckbox  = itemArr.isparentcheckbox

    //     if(itemArr.texturename){
    //         tmpSiyoDataObj.tablename = 'Texture' 
    //         tmpSiyoDataObj.parentname = itemArr.foldername
    //         tmpSiyoDataObj.parentid = itemArr.folderid
    //         tmpSiyoDataObj.valuename = itemArr.texturename
    //         tmpSiyoDataObj.isunchecktexture = 0    
    //         tmpSiyoDataObj.istexture  = 0
    //     }else{
    //         tmpSiyoDataObj.istexture  = itemArr.istexture
    //         tmpSiyoDataObj.isunchecktextures  = itemArr.isunchecktextures
    //         tmpSiyoDataObj.tablename = 'Master'
    //         tmpSiyoDataObj.parentname = itemArr.parentname
    //         tmpSiyoDataObj.parentid = itemArr.parentid
    //         tmpSiyoDataObj.valuename = itemArr.items
    //     }

    //     return tmpSiyoDataObj 
    // }
  
    static SelectedDataObj = (filteredMaincategory, filteredCategory, filteredSubcategory, filteredSpecs, textureInfo, isClicked = false) =>{
        function filteredComments(comment, houseTypeArr, currHouseType){
            result = null

            if(houseTypeArr){
                if(houseTypeArr.includes( currHouseType )){
                    result = comment
                }   
            }

            return result
        }

        let tmpRowIndex    = null
        let Seq  = 1
        let tmpTextureInfo = {}
        let tmpiCADTableArr = []
        const houseTypeNumber = this.HouseTypeNumber();

        let maincategory = {
            name        : null,
            comment     : null,
            id          : null,
            sort        : null,
            groupid     : null,
            selectionid : null,
            parentid    : null,
            valuecode   : null,
            categorycode: null,
            istexture   : null,
        }

        let category = {
            name        : null,
            comment     : null,
            id          : null,
            sort        : null,
            groupid     : null,
            selectionid : null,
            parentid    : null,
            valuecode   : null,
            categorycode: null,
            ischeckbox: null,
            istexture   : null,
            icadtable   : null,
        }

        let subcategory = {
            name        : null,
            comment     : null,
            id          : null,
            sort        : null,
            groupid     : null,
            selectionid : null,
            parentid    : null,
            valuecode   : null,
            categorycode: null,
            ischeckbox: null,
            istexture   : null,
            icadtable   : null,
        }

        let specs = {
            name        : null,
            comment     : null,
            id          : null,
            sort        : null,
            groupid     : null,
            selectionid : null,
            parentid    : null,
            valuecode   : null,
            categorycode: null,
            ischeckbox: null,
            istexture   : null,
            icadtable   : null,
        }

        //texture
        let texture = {
            name        : null,
            comment     : null,
            id          : null,
            sort        : null,
            groupid     : null,
            selectionid : null,
            parentid    : null,
            valuecode   : null,
            categorycode: null,
            icadtableid : null, 
            icadtable   : null,
        }

        //Maincategory
        if (filteredMaincategory) {
            maincategory.name        = filteredMaincategory.items
            maincategory.comment = filteredMaincategory.comment
            maincategory.id           = filteredMaincategory.id
            maincategory.sort         = filteredMaincategory.sortno
            maincategory.selectionid  = filteredMaincategory.selectionid
            maincategory.masterid     = filteredMaincategory.masterid
            maincategory.floor        = filteredMaincategory.floor
            maincategory.itemnumber   = filteredMaincategory.itemnumber
            maincategory.roomname     = filteredMaincategory.roomname
            maincategory.hinban       = filteredMaincategory.hinban
            maincategory.parentid     = filteredMaincategory.parentid
            maincategory.valuecode    = filteredMaincategory.valuecode 
            maincategory.categorycode = filteredMaincategory.categorycode  
            
            tmpRowIndex = filteredMaincategory.id.toString() //2021-09-23 jazz autocreate rowindex based on condition 
        }

        //Category
        if (filteredCategory) {
            category.name         = filteredCategory.items
            category.comment      = filteredCategory.comment
            category.id           = filteredCategory.id
            category.sort         = filteredCategory.sortno
            category.selectionid  = filteredCategory.selectionid
            category.parentid     = filteredCategory.parentid
            category.valuecode    = filteredCategory.valuecode 
            category.categorycode = filteredCategory.categorycode   
            category.ischeckbox   = filteredCategory.ischeckbox 
            category.istexture    = filteredCategory.istexture 
            category.icadtable    = filteredCategory.icadtable
            
            tmpiCADTableArr.push(filteredCategory.icadtableid)

            if (filteredCategory.ischeckbox == 0) {
                tmpRowIndex = tmpRowIndex + filteredCategory.id 
            }  
        }

        //Subcategory
        if (filteredSubcategory) {
            subcategory.name        = filteredSubcategory.items
            subcategory.comment        = filteredSubcategory.comment
            subcategory.id           = filteredSubcategory.id
            subcategory.sort         = filteredSubcategory.sortno
            subcategory.selectionid  = filteredSubcategory.selectionid
            subcategory.parentid     = filteredSubcategory.parentid
            subcategory.valuecode    = filteredSubcategory.valuecode 
            subcategory.categorycode = filteredSubcategory.categorycode
            subcategory.ischeckbox   = filteredSubcategory.ischeckbox
            subcategory.istexture    = filteredSubcategory.istexture
            subcategory.icadtable    = filteredSubcategory.icadtable

            tmpiCADTableArr.push(filteredSubcategory.icadtableid)

            if (filteredSubcategory.ischeckbox == 0) {
                tmpRowIndex = tmpRowIndex + filteredSubcategory.id 
            }      
        }
  
        //Specs
        if (filteredSpecs) {
            specs.name         = filteredSpecs.items
            specs.comment         = filteredSpecs.comment
            specs.id           = filteredSpecs.id
            specs.sort         = filteredSpecs.sortno
            specs.selectionid  = filteredSpecs.selectionid
            specs.parentid     = filteredSpecs.parentid
            specs.valuecode    = filteredSpecs.valuecode 
            specs.categorycode = filteredSpecs.categorycode
            specs.ischeckbox   = filteredSpecs.ischeckbox
            specs.istexture    = filteredSpecs.istexture
            specs.icadtable    = filteredSpecs.icadtable

            tmpiCADTableArr.push(filteredSpecs.icadtableid)

            if (filteredSpecs.ischeckbox == 0) {
                tmpRowIndex = tmpRowIndex + filteredSpecs.id
            } 
        }

        //texture 
        if (textureInfo) {
            texture.name         = textureInfo.texturename
            texture.comment      = textureInfo.comment
            texture.id           = textureInfo.id
            texture.sort         = textureInfo.sortno
            texture.selectionid  = textureInfo.selectionid
            texture.parentid     = textureInfo.folderid
            texture.valuecode    = textureInfo.valuecode 
            texture.categorycode = textureInfo.categorycode
            texture.icadtableid  = textureInfo.icadtableid
            texture.icadtable    = textureInfo.icadtable

            tmpiCADTableArr.push(textureInfo.icadtableid)
        }  

        let tmpiCADFolderArr = [maincategory.icadtable, category.icadtable, subcategory.icadtable, specs.icadtable, texture.icadtable] 
        let tmpiCADFolderId = null


        for(let k = 0; k < tmpiCADFolderArr.length; k++){
            if(tmpiCADFolderArr[k]){
                tmpiCADFolderId = tmpiCADFolderArr[k]    
            }
        }

        //Append the last digit of the maincategory name to rowindex for multiple items
        if (/\([2-9]|[1][0-9]|20|[2][1-9]|30\)$/.test(filteredMaincategory.items)) { //modify by mae 2025-04-25
            tmpRowIndex = tmpRowIndex + filteredMaincategory.items.substr(filteredMaincategory.items.length-2, 1)
            Seq = parseInt(filteredMaincategory.items.substr(filteredMaincategory.items.length-2, 1)) 
        } 

        //Structure JSON Object to be loaded in SRS
        tmpTextureInfo.RowIndex = tmpRowIndex
  
        //Maincategory
        tmpTextureInfo.MainCategoryName         = maincategory.name
        tmpTextureInfo.MainCategoryComment      = maincategory.comment
        tmpTextureInfo.MainCategoryId           = maincategory.id
        tmpTextureInfo.MainCategoryCategoryCode = maincategory.categorycode
        tmpTextureInfo.MainCategoryValueCode    = maincategory.valuecode
        tmpTextureInfo.MainCategoryParentId     = maincategory.parentid
        tmpTextureInfo.Seq                      = Seq
        tmpTextureInfo.Kind                     = maincategory.name
        tmpTextureInfo.SortNo                   = maincategory.sort 
        tmpTextureInfo.MasterId                 = maincategory.masterid
        tmpTextureInfo.MainCategorySelectionId  = maincategory.selectionid
        tmpTextureInfo.Floor                    = filteredMaincategory.floor 
        tmpTextureInfo.ItemNumber               = filteredMaincategory.itemnumber  
        tmpTextureInfo.RoomName                 = filteredMaincategory.roomname 
        tmpTextureInfo.Hinban                   = filteredMaincategory.hinban
        tmpTextureInfo.istexture                = maincategory.istexture
        
        //Category
        tmpTextureInfo.CategoryName         = category.name
        tmpTextureInfo.CategoryComment      = category.comment
        tmpTextureInfo.CategoryId           = category.id
        tmpTextureInfo.CategoryCategoryCode = category.categorycode
        tmpTextureInfo.CategoryValueCode    = category.valuecode
        tmpTextureInfo.CategorySort         = category.sort
        tmpTextureInfo.CategorySelectionId  = category.selectionid
        tmpTextureInfo.CategoryParentId     = category.parentid
        tmpTextureInfo.IsCategoryCheckbox   = category.ischeckbox
        tmpTextureInfo.categoryisTexture    = category.istexture

        //Subcategory
        tmpTextureInfo.SubcategoryName         = subcategory.name
        tmpTextureInfo.SubcategoryComment      = subcategory.comment
        tmpTextureInfo.SubcategoryId           = subcategory.id
        tmpTextureInfo.SubcategoryCategoryCode = subcategory.categorycode
        tmpTextureInfo.SubcategoryValueCode    = subcategory.valuecode
        tmpTextureInfo.SubcategorySort         = subcategory.sort
        tmpTextureInfo.SubcategorySelectionId  = subcategory.selectionid
        tmpTextureInfo.SubcategoryParentId     = subcategory.parentid
        tmpTextureInfo.IsSubcategoryCheckbox   = subcategory.ischeckbox
        tmpTextureInfo.subcategoryisTexture    = subcategory.istexture

        // //Specs
        tmpTextureInfo.SpecsName         = specs.name
        tmpTextureInfo.SpecsComment      = specs.comment
        tmpTextureInfo.SpecsId           = specs.id
        tmpTextureInfo.SpecsCategoryCode = specs.categorycode
        tmpTextureInfo.SpecsValueCode    = specs.valuecode
        tmpTextureInfo.SpecsSort         = specs.sort
        tmpTextureInfo.SpecsSelectionId  = specs.selectionid
        tmpTextureInfo.SpecsParentId     = specs.parentid
        tmpTextureInfo.IsSpecsCheckbox   = specs.ischeckbox
        tmpTextureInfo.specsisTexture    = specs.istexture

        tmpTextureInfo.Modified = isClicked

        //Texture
        tmpTextureInfo.TextureName         = texture.name
        tmpTextureInfo.TextureComment      = texture.comment
        tmpTextureInfo.TextureId           = texture.id
        tmpTextureInfo.TextureCategoryCode = texture.categorycode
        tmpTextureInfo.TextureValueCode    = texture.valuecode
        tmpTextureInfo.TextureSort         = texture.sort
        tmpTextureInfo.TextureSelectionId  = texture.selectionid 
        tmpTextureInfo.TextureParentId     = texture.parentid

        tmpTextureInfo.iCADFolderId  = tmpiCADFolderId
 
        //tmpTextureInfo.iCADFolderId  = (tmpTextureInfo.iCADFolderId == -1) ? texture.icadtable:-1
 
        tmpTextureInfo.iCADTextureId = texture.icadtableid ? texture.icadtableid: -1

        return tmpTextureInfo
    }
} //End Class